export const UVT_MATERIAS = {
    admin: {
        1: {
            description: "1er cuatrimestre",
            materias: [
                {
                    name: "ADMINISTRACIÓN ",
                    topicId: "FB-392101",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: false,
                    objective: "Identificar el desarrollo histórico de la administración; analizar las principales escuelas " +
                        "de la teoría administrativa, sus aportaciones, técnicas, su función y relación con el contexto " +
                        "social, evaluar y enfocar la administración en nuestro país y valorar la necesidad social, perfil, " +
                        "campos de actuación y código de ética de la administración."
                },
                {
                    name: "CONTABILIDAD ",
                    topicId: "FB-392102",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: false,
                    objective: "Identificar la naturaleza de la contabilidad, sus normas de actuación, el significado de la " +
                        "información financiera y los principios de contabilidad. Conocer y elaborar el estado de situación " +
                        "financiera (balance general) y el estado de resultados, explicar la partida doble y la cuenta y su " +
                        "aplicación en el registro de operaciones."
                },
                {
                    name: "TECNOLOGÍAS DE LA INFORMACIÓN Y COMUNICACIÓN ",
                    topicId: "FB-392103",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: false,
                    objective: "Identificar el uso en las empresas de las TIC´s para toma de decisiones estratégicas, a partir de la comprensión de las ventajas que otorga emplear dispositivos electrónicos, plataformas y aplicaciones de uso empresarial, considerando de igual forma las medidas de seguridad necesarias para cuidar a la organización."
                },
                {
                    name: "MATÉMATICAS PARA ADMINISTRACIÓN",
                    topicId: "FB-392104",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    temas: [
                        {descripcion: "Funciones matemáticas y ecuaciones lineales.", horasIndependientes: 15, horasDocente: 10,
                            subtemas: [
                                {subtema: "1.1 Definición"},
                                {subtema: "1.2 Dominio y rango restringidos"},
                                {subtema: "1.3 Funciones multivariadas básicas"},
                                {subtema: "1.4 Representaciones gráficas de funciones matemáticas"},
                                {subtema: "1.5 Formula pendiente intersección"},
                                {subtema: "1.6 Determinación de la ecuación de una línea recta "},
                            ]},
                        {descripcion: "Aplicaciones de funciones lineales y sistemas de ecuaciones", horasIndependientes: 15, horasDocente: 10,
                            subtemas: [
                                {subtema: "2.1 Funciones lineales "},
                                {subtema: "2.2 Modelos de equilibrio "},
                                {subtema: "2.3 Sistemas de ecuaciones lineales "},
                            ]},
                        {descripcion: "Álgebra matricial", horasIndependientes: 20, horasDocente: 10,
                            subtemas: [
                                {subtema: "3.1 Introducción a las matrices"},
                                {subtema: "3.2 Tipos de matrices"},
                                {subtema: "3.3 Operaciones con matrices"},
                                {subtema: "3.4 Introducción a los determinantes"},
                                {subtema: "3.5 Propiedades de los determinantes"},
                                {subtema: "3.6 Solución de una matriz inversa"},
                                {subtema: "3.7 Aplicaciones"},
                            ]},
                        {descripcion: "Cálculo diferencial e integral", horasIndependientes: 20, horasDocente: 12,
                            subtemas: [
                                {subtema: "4.1 Límites y continuidad de una función"},
                                {subtema: "4.2 Derivadas"},
                                {subtema: "4.3 Aplicaciones de la derivada"},
                                {subtema: "4.4 Antiderivada"},
                                {subtema: "4.5 Integrales"},
                                {subtema: "4.6 Aplicación del cálculo integral"},
                            ]},
                    ],
                    disabled: false,
                    objective: "Aplicar el lenguaje algebraico mediante la interpretación y operación de expresiones matemáticas, así como su representación gráfica correspondiente para formular y resolver problemas.",
                    actividadesConAcademico: [
                        {actividad: "Revisará en la plataforma institucional el avance de las participaciones, tareas, trabajos y demás aspectos  para la evaluación de los aprendizajes."},
                        {actividad: "Orientación, guía y acompañamiento al estudiante en su proceso de aprendizaje, a partir de tareas, trabajos y demás aspectos que fomenten el trabajo independiente y colaborativo a distancia."},
                        {actividad: "Asesoría a través de la plataforma educativa institucional con el apoyo de herramientas para la educación a distancia: chad, foro de diálogo, salas virtuales, carpeta de lecciones, carpeta de actividades, y correo electrónico institucional."},
                        {actividad: "Revisión con el alumno del plan de trabajo ofreciendo las instrucciones detalles sobre la preparación de las unidades, temas, trabajos a elaborar, actividades , prácticas, ejercicios, herramientas digitales, requisitos para exámenes de evaluación y otras sugeridas previamente por el docente para reforzar el proceso de enseñanza-aprendizaje a distancia."},
                        {actividad: "Implementar estrategias para que los estudiantes realicen actividades orientadas a la solución de problemas, construcción de modelos matemáticos, utilizando las herramientas disponibles en la plataforma educativa institucional y sitios de internet afines a la asignatura. "},
                        {actividad: "Aplicará acciones para su evaluación, retroalimentación y reforzamiento del aprendizaje."},
                    ],
                    actividadesIndependientes: [
                        {actividad: "Participar en las actividades establecidas en la Plataforma Educativa Institucional en donde deberá cumplir puntualmente con todas aquellas que indique el docente."},
                        {actividad: "Establecer un calendario que le permita la realización oportuna de sus actividades escolares y todas aquellas acciones que le faciliten el cumplimiento del plan de trabajo establecido de antemano por el académico."},
                        {actividad: "Seleccionar las estrategias de trabajo que le faciliten la adquisición, comprensión y utilización de información para apropiarse del conocimiento."},
                        {actividad: "Formular dudas concretas, comentarios y aportaciones profesionales, para promover el diálogo y la discusión con el académico y los compañeros, en la Plataforma Educativa Institucional, para generar información pertinente para todos los participantes. "},
                        {actividad: "Aplicar las herramientas didácticas digitales con las que reforzará el conocimiento por adquirir."},
                        {actividad: "Realizar trabajo de investigación previo a las sesiones virtuales"},
                        {actividad: "Consulta bibliográfica en la biblioteca virtual"},
                        {actividad: "Resolución de ejercicios propuestos utilizando las herramientas disponibles en la plataforma educativa institucional. "},
                        {actividad: "Representar gráficamente las funciones matemáticas propuestas con la herramienta digital disponible en la plataforma virtual o la aplicación sugerida."},
                    ],
                    evaluacion: {
                        procedimientos: [
                            {procedimiento: "Evaluaciones parciales."},
                            {procedimiento: "Evaluación final."},
                            {procedimiento: "Trabajos y tareas establecidos en la Plataforma Educativa Institucional"},
                            {procedimiento: "Participación en foros, chats y salas en la Plataforma Educativa Institucional."},
                            {procedimiento: "Proyectos y/o prácticas en colaboración."},
                        ],
                        acreditacion: "Las evaluaciones se efectuarán en la forma y condiciones que el programa académico establezca. Los resultados de las evaluaciones se efectuarán en las fechas señaladas por el departamento de control escolar, bajo la escala numérica del 5 al 10, considerando como calificación mínima aprobatoria seis.",
                        rubricas: [
                            {rubrica: "Evaluaciones de conocimiento parciales.", porcentaje: 15, porcentajeString: "15%"},
                            {rubrica: "Practicar dos exámenes como mínimo durante el curso.", porcentaje: 15, porcentajeString: "15%"},
                            {rubrica: "Trabajos de investigación, tareas, participación en clase, asistencia a conferencias y demás aspectos susceptibles de ser evaluados.", porcentaje: 15, porcentajeString: "15%"},
                            {rubrica: "Participación en foros, chats y salas en la Plataforma Educativa Institucional.", porcentaje: 30, porcentajeString: "30%"},
                            {rubrica: "Proyectos y/o prácticas en colaboración.", porcentaje: 25, porcentajeString: "25%"},
                        ]
                    },
                    recursos: [
                        {recurso: "Entorno de aprendizaje virtual: Plataforma educativa institucional"},
                        {recurso: "Chat virtual para diálogo con los estudiantes"},
                        {recurso: "Correo electrónico institucional"},
                        {recurso: "Foro de discusión virtual"},
                        {recurso: "Biblioteca Digital"},
                        {recurso: "Videoconferencias "},
                        {recurso: "Webinars de temas especializados"},
                        {recurso: "Aplicaciones para generar presentaciones digitales"},
                        {recurso: "Pizarra digital"},
                    ]
                },
                {
                    name: "METODOLOGÍA DE LA INVESTIGACIÓN",
                    topicId: "FB-392105",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Proporcionar al estudiante las herramientas y conocimientos para la realización de investigación documentada y experimental, así como las bases para la interpretación, discusión y presentación de resultados para explicar fenómenos de la sociedad y aplicarlo en su formación profesional y laboral."
                },
                {
                    name: "CONCEPTOS JURÍDICOS",
                    topicId: "FB-392106",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "El alumno comprenderá los conceptos jurídicos fundamentales, que le sirvan de fundamento en sus estudios de preparación en el área económico-administrativa a la que pertenece."
                },
            ]
        },
        2: {
            description: "2do cuatrimestre",
            materias: [
                {
                    name: "PROCESO ADMINISTRATIVO",
                    topicId: "FB-392107",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Describir, analizar y relacionar las etapas del proceso administrativo, con las áreas funcionales en las organizaciones y su relación con las áreas funcionales de la organización.",
                },
                {
                    name: "CONTABILIDAD ADMINISTRATIVA",
                    topicId: "FB-392108",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Utilizar la Contabilidad Administrativa como una herramienta útil en la toma de decisiones dentro del proceso de planeación y control de las organizaciones. Así como registrar operaciones de compra y venta de mercancías aplicando métodos de valuación de inventarios, manuales y electrónicos.",
                },
                {
                    name: "COMERCIO ELECTRÓNICO",
                    topicId: "FB-392109",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Evaluar los recursos y herramientas existentes para brindar soluciones a las empresas que buscan incursionar en el comercio en el entorno digital.",
                },
                {
                    name: "MATEMÁTICAS FINANCIERAS",
                    topicId: "FB-392110",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Evaluar los modelos financieros aplicando los principios matemáticos referentes a la variación del dinero en el tiempo.",
                },
                {
                    name: "MACROECONOMÍA",
                    topicId: "FB-392111",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Utilizar los conceptos de la teoría económica, evaluar las relaciones macroeconómicas y emplear las leyes económicas como instrumento de análisis.",
                },
                {
                    name: "DERECHO MERCANTIL",
                    topicId: "FB-392112",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Analizar la necesidad e importancia del derecho mercantil, las personas que intervienen, los actos de comercio, la empresa y sus elementos, los contratos mercantiles, títulos y operaciones de crédito determinando su aplicación.",
                },
            ]
        },
        3: {
            description: "3er cuatrimestre",
            materias: [
                {
                    name: "MARCO ORGANIZACIONAL DE LA ADMINISTRACIÓN",
                    topicId: "FB-392113",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Señalar la problemática existente en las organizaciones, analizar, diseñar o rediseñar la estructura de la organización y formular el manual de organización.",
                },
                {
                    name: "EMPRENDIMIENTO",
                    topicId: "FB-392114",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Conocer el proceso de creación de empresas, las etapas para generar el plan de negocio, el producto/servicio a ofrecer en el mercado, financiamiento y consolidación.",
                },
                {
                    name: "CAPITAL HUMANO I",
                    topicId: "FB-392115",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Comprender el papel estratégico de la administración del capital humano en las organizaciones, los sistemas de información empleados en su manejo, y la funcionalidad del análisis y diseño de puestos.",
                },
                {
                    name: "ANÁLISIS ESTADÍSTICO I",
                    topicId: "FB-392116",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "MICROECONOMÍA",
                    topicId: "FB-392117",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "DERECHO LABORAL",
                    topicId: "FB-392118",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        4: {
            description: "4to cuatrimestre",
            materias: [
                {
                    name: "SISTEMAS ADMINISTRATIVOS EN LAS ORGANIZACIONES",
                    topicId: "FP-392119",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ENTORNO ECONÓMICO DE MÉXICO",
                    topicId: "FP-392120",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "PSICOLOGÍA ORGANIZACIONAL",
                    topicId: "FP-392121",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "CAPITAL HUMANO II",
                    topicId: "FP-392122",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ANÁLISIS ESTADÍSTICO II",
                    topicId: "FP-392123",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "CIBER SEGURIDAD EN LAS EMPRESAS ",
                    topicId: "FP-392124",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        5: {
            description: "5to cuatrimestre",
            materias: [
                {
                    name: "DIRECCIÓN, LIDERÁZGO Y TOMA DE DESICIONES",
                    topicId: "FP-392125",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "FINANZAS I",
                    topicId: "FP-392126",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "COMPORTAMIENTO HUMANO EN LAS ORGANIZACIONES",
                    topicId: "FP-392127",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "INVESTIGACIÓN DE OPERACIONES",
                    topicId: "FP-392128",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "FUNDAMENTOS DE LA MERCADOTECNIA ",
                    topicId: "FP-392129",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "SISTEMAS DE INFORMACIÓN PARA LAS EMPRESAS",
                    topicId: "FP-392130",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        6: {
            description: "6to cuatrimestre",
            materias: [
                {
                    name: "NEGOCIOS GLOBALES",
                    topicId: "FP-392131",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "FINANZAS II",
                    topicId: "FP-392132",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "OPERACIONES I",
                    topicId: "FP-392133",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ADMINISTRACIÓN DE PROYECTOS",
                    topicId: "FP-392134",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "MERCADOTECNIA DIGITAL",
                    topicId: "FP-392135",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        7: {
            description: "7mo cuatrimestre",
            materias: [
                {
                    name: "AUDITORÍA ADMINISTRATIVA I",
                    topicId: "FP-392136",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "FINANZAS INTERNACIONALES",
                    topicId: "FP-392137",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "OPERACIONES II",
                    topicId: "FP-392138",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ADMINISTRACIÓN DE LA MIPyME",
                    topicId: "FP-392139",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "COACHING GERENCIAL",
                    topicId: "FP-392140",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        8: {
            description: "8vo cuatrimestre",
            materias: [
                {
                    name: "PRESUPUESTOS",
                    topicId: "FE-392141",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "AUDITORÍA ADMINISTRATIVA II",
                    topicId: "FE-392142",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "RELACIONES PÚBLICAS",
                    topicId: "FE-392143",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "DESARROLLO EMPRESARIAL",
                    topicId: "FE-392144",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ADMINISTRACIÓN DE LOS COSTOS",
                    topicId: "FE-392145",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        9: {
            description: "9no cuatrimestre",
            materias: [
                {
                    name: "PLANEACIÓN ESTRATÉGICA",
                    topicId: "FE-392146",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "CALIDAD TOTAL",
                    topicId: "FE-392147",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "SEMINARIO DE TESIS",
                    topicId: "FE-392148",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "DIAGNÓSTICO ORGANIZACIONAL",
                    topicId: "FE-392149",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "DESARROLLO SUSTENTABLE CORPORATIVO",
                    topicId: "FE-392150",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        }
    },
    psico: {
        1: {
            description: "1er cuatrimestre",
            materias: [
                {
                    name: "APRENDER EN EL SISTEMA EDUCATIVO VIRTUAL",
                    topicId: "FB-392101",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: false,
                    objective: "Identificar el desarrollo histórico de la administración; analizar las principales escuelas " +
                        "de la teoría administrativa, sus aportaciones, técnicas, su función y relación con el contexto " +
                        "social, evaluar y enfocar la administración en nuestro país y valorar la necesidad social, perfil, " +
                        "campos de actuación y código de ética de la administración."
                },
                {
                    name: "PSICOLOGÍA GENERAL",
                    topicId: "FB-392102",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: false,
                    objective: "Identificar la naturaleza de la contabilidad, sus normas de actuación, el significado de la " +
                        "información financiera y los principios de contabilidad. Conocer y elaborar el estado de situación " +
                        "financiera (balance general) y el estado de resultados, explicar la partida doble y la cuenta y su " +
                        "aplicación en el registro de operaciones."
                },
                {
                    name: "PEDAGOGÍA I",
                    topicId: "FB-392103",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: false,
                    objective: "Identificar el uso en las empresas de las TIC´s para toma de decisiones estratégicas, a partir de la comprensión de las ventajas que otorga emplear dispositivos electrónicos, plataformas y aplicaciones de uso empresarial, considerando de igual forma las medidas de seguridad necesarias para cuidar a la organización."
                },
                {
                    name: "METODOLOGÍA DE LA INVESTIGACIÓN I",
                    topicId: "FB-392104",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    temas: [
                        {
                            descripcion: "Funciones matemáticas y ecuaciones lineales.",
                            horasIndependientes: 15,
                            horasDocente: 10,
                            subtemas: [
                                {subtema: "1.1 Definición"},
                                {subtema: "1.2 Dominio y rango restringidos"},
                                {subtema: "1.3 Funciones multivariadas básicas"},
                                {subtema: "1.4 Representaciones gráficas de funciones matemáticas"},
                                {subtema: "1.5 Formula pendiente intersección"},
                                {subtema: "1.6 Determinación de la ecuación de una línea recta "},
                            ]
                        },
                        {
                            descripcion: "Aplicaciones de funciones lineales y sistemas de ecuaciones",
                            horasIndependientes: 15,
                            horasDocente: 10,
                            subtemas: [
                                {subtema: "2.1 Funciones lineales "},
                                {subtema: "2.2 Modelos de equilibrio "},
                                {subtema: "2.3 Sistemas de ecuaciones lineales "},
                            ]
                        },
                        {
                            descripcion: "Álgebra matricial", horasIndependientes: 20, horasDocente: 10,
                            subtemas: [
                                {subtema: "3.1 Introducción a las matrices"},
                                {subtema: "3.2 Tipos de matrices"},
                                {subtema: "3.3 Operaciones con matrices"},
                                {subtema: "3.4 Introducción a los determinantes"},
                                {subtema: "3.5 Propiedades de los determinantes"},
                                {subtema: "3.6 Solución de una matriz inversa"},
                                {subtema: "3.7 Aplicaciones"},
                            ]
                        },
                        {
                            descripcion: "Cálculo diferencial e integral", horasIndependientes: 20, horasDocente: 12,
                            subtemas: [
                                {subtema: "4.1 Límites y continuidad de una función"},
                                {subtema: "4.2 Derivadas"},
                                {subtema: "4.3 Aplicaciones de la derivada"},
                                {subtema: "4.4 Antiderivada"},
                                {subtema: "4.5 Integrales"},
                                {subtema: "4.6 Aplicación del cálculo integral"},
                            ]
                        },
                    ],
                    disabled: false,
                    objective: "Aplicar el lenguaje algebraico mediante la interpretación y operación de expresiones matemáticas, así como su representación gráfica correspondiente para formular y resolver problemas.",
                    actividadesConAcademico: [
                        {actividad: "Revisará en la plataforma institucional el avance de las participaciones, tareas, trabajos y demás aspectos  para la evaluación de los aprendizajes."},
                        {actividad: "Orientación, guía y acompañamiento al estudiante en su proceso de aprendizaje, a partir de tareas, trabajos y demás aspectos que fomenten el trabajo independiente y colaborativo a distancia."},
                        {actividad: "Asesoría a través de la plataforma educativa institucional con el apoyo de herramientas para la educación a distancia: chad, foro de diálogo, salas virtuales, carpeta de lecciones, carpeta de actividades, y correo electrónico institucional."},
                        {actividad: "Revisión con el alumno del plan de trabajo ofreciendo las instrucciones detalles sobre la preparación de las unidades, temas, trabajos a elaborar, actividades , prácticas, ejercicios, herramientas digitales, requisitos para exámenes de evaluación y otras sugeridas previamente por el docente para reforzar el proceso de enseñanza-aprendizaje a distancia."},
                        {actividad: "Implementar estrategias para que los estudiantes realicen actividades orientadas a la solución de problemas, construcción de modelos matemáticos, utilizando las herramientas disponibles en la plataforma educativa institucional y sitios de internet afines a la asignatura. "},
                        {actividad: "Aplicará acciones para su evaluación, retroalimentación y reforzamiento del aprendizaje."},
                    ],
                    actividadesIndependientes: [
                        {actividad: "Participar en las actividades establecidas en la Plataforma Educativa Institucional en donde deberá cumplir puntualmente con todas aquellas que indique el docente."},
                        {actividad: "Establecer un calendario que le permita la realización oportuna de sus actividades escolares y todas aquellas acciones que le faciliten el cumplimiento del plan de trabajo establecido de antemano por el académico."},
                        {actividad: "Seleccionar las estrategias de trabajo que le faciliten la adquisición, comprensión y utilización de información para apropiarse del conocimiento."},
                        {actividad: "Formular dudas concretas, comentarios y aportaciones profesionales, para promover el diálogo y la discusión con el académico y los compañeros, en la Plataforma Educativa Institucional, para generar información pertinente para todos los participantes. "},
                        {actividad: "Aplicar las herramientas didácticas digitales con las que reforzará el conocimiento por adquirir."},
                        {actividad: "Realizar trabajo de investigación previo a las sesiones virtuales"},
                        {actividad: "Consulta bibliográfica en la biblioteca virtual"},
                        {actividad: "Resolución de ejercicios propuestos utilizando las herramientas disponibles en la plataforma educativa institucional. "},
                        {actividad: "Representar gráficamente las funciones matemáticas propuestas con la herramienta digital disponible en la plataforma virtual o la aplicación sugerida."},
                    ],
                    evaluacion: {
                        procedimientos: [
                            {procedimiento: "Evaluaciones parciales."},
                            {procedimiento: "Evaluación final."},
                            {procedimiento: "Trabajos y tareas establecidos en la Plataforma Educativa Institucional"},
                            {procedimiento: "Participación en foros, chats y salas en la Plataforma Educativa Institucional."},
                            {procedimiento: "Proyectos y/o prácticas en colaboración."},
                        ],
                        acreditacion: "Las evaluaciones se efectuarán en la forma y condiciones que el programa académico establezca. Los resultados de las evaluaciones se efectuarán en las fechas señaladas por el departamento de control escolar, bajo la escala numérica del 5 al 10, considerando como calificación mínima aprobatoria seis.",
                        rubricas: [
                            {
                                rubrica: "Evaluaciones de conocimiento parciales.",
                                porcentaje: 15,
                                porcentajeString: "15%"
                            },
                            {
                                rubrica: "Practicar dos exámenes como mínimo durante el curso.",
                                porcentaje: 15,
                                porcentajeString: "15%"
                            },
                            {
                                rubrica: "Trabajos de investigación, tareas, participación en clase, asistencia a conferencias y demás aspectos susceptibles de ser evaluados.",
                                porcentaje: 15,
                                porcentajeString: "15%"
                            },
                            {
                                rubrica: "Participación en foros, chats y salas en la Plataforma Educativa Institucional.",
                                porcentaje: 30,
                                porcentajeString: "30%"
                            },
                            {
                                rubrica: "Proyectos y/o prácticas en colaboración.",
                                porcentaje: 25,
                                porcentajeString: "25%"
                            },
                        ]
                    },
                    recursos: [
                        {recurso: "Entorno de aprendizaje virtual: Plataforma educativa institucional"},
                        {recurso: "Chat virtual para diálogo con los estudiantes"},
                        {recurso: "Correo electrónico institucional"},
                        {recurso: "Foro de discusión virtual"},
                        {recurso: "Biblioteca Digital"},
                        {recurso: "Videoconferencias "},
                        {recurso: "Webinars de temas especializados"},
                        {recurso: "Aplicaciones para generar presentaciones digitales"},
                        {recurso: "Pizarra digital"},
                    ]
                },
                {
                    name: "METODOLOGÍA DE LA INVESTIGACIÓN",
                    topicId: "FB-392105",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Proporcionar al estudiante las herramientas y conocimientos para la realización de investigación documentada y experimental, así como las bases para la interpretación, discusión y presentación de resultados para explicar fenómenos de la sociedad y aplicarlo en su formación profesional y laboral."
                },
                {
                    name: "CONCEPTOS JURÍDICOS",
                    topicId: "FB-392106",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "El alumno comprenderá los conceptos jurídicos fundamentales, que le sirvan de fundamento en sus estudios de preparación en el área económico-administrativa a la que pertenece."
                },
            ]
        },
        2: {
            description: "2do cuatrimestre",
            materias: [
                {
                    name: "PROCESO ADMINISTRATIVO",
                    topicId: "FB-392107",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Describir, analizar y relacionar las etapas del proceso administrativo, con las áreas funcionales en las organizaciones y su relación con las áreas funcionales de la organización.",
                },
                {
                    name: "CONTABILIDAD ADMINISTRATIVA",
                    topicId: "FB-392108",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Utilizar la Contabilidad Administrativa como una herramienta útil en la toma de decisiones dentro del proceso de planeación y control de las organizaciones. Así como registrar operaciones de compra y venta de mercancías aplicando métodos de valuación de inventarios, manuales y electrónicos.",
                },
                {
                    name: "COMERCIO ELECTRÓNICO",
                    topicId: "FB-392109",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Evaluar los recursos y herramientas existentes para brindar soluciones a las empresas que buscan incursionar en el comercio en el entorno digital.",
                },
                {
                    name: "MATEMÁTICAS FINANCIERAS",
                    topicId: "FB-392110",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Evaluar los modelos financieros aplicando los principios matemáticos referentes a la variación del dinero en el tiempo.",
                },
                {
                    name: "MACROECONOMÍA",
                    topicId: "FB-392111",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Utilizar los conceptos de la teoría económica, evaluar las relaciones macroeconómicas y emplear las leyes económicas como instrumento de análisis.",
                },
                {
                    name: "DERECHO MERCANTIL",
                    topicId: "FB-392112",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Analizar la necesidad e importancia del derecho mercantil, las personas que intervienen, los actos de comercio, la empresa y sus elementos, los contratos mercantiles, títulos y operaciones de crédito determinando su aplicación.",
                },
            ]
        },
        3: {
            description: "3er cuatrimestre",
            materias: [
                {
                    name: "MARCO ORGANIZACIONAL DE LA ADMINISTRACIÓN",
                    topicId: "FB-392113",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Señalar la problemática existente en las organizaciones, analizar, diseñar o rediseñar la estructura de la organización y formular el manual de organización.",
                },
                {
                    name: "EMPRENDIMIENTO",
                    topicId: "FB-392114",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Conocer el proceso de creación de empresas, las etapas para generar el plan de negocio, el producto/servicio a ofrecer en el mercado, financiamiento y consolidación.",
                },
                {
                    name: "CAPITAL HUMANO I",
                    topicId: "FB-392115",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Comprender el papel estratégico de la administración del capital humano en las organizaciones, los sistemas de información empleados en su manejo, y la funcionalidad del análisis y diseño de puestos.",
                },
                {
                    name: "ANÁLISIS ESTADÍSTICO I",
                    topicId: "FB-392116",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "MICROECONOMÍA",
                    topicId: "FB-392117",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "DERECHO LABORAL",
                    topicId: "FB-392118",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        4: {
            description: "4to cuatrimestre",
            materias: [
                {
                    name: "SISTEMAS ADMINISTRATIVOS EN LAS ORGANIZACIONES",
                    topicId: "FP-392119",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ENTORNO ECONÓMICO DE MÉXICO",
                    topicId: "FP-392120",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "PSICOLOGÍA ORGANIZACIONAL",
                    topicId: "FP-392121",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "CAPITAL HUMANO II",
                    topicId: "FP-392122",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ANÁLISIS ESTADÍSTICO II",
                    topicId: "FP-392123",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "CIBER SEGURIDAD EN LAS EMPRESAS ",
                    topicId: "FP-392124",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        5: {
            description: "5to cuatrimestre",
            materias: [
                {
                    name: "DIRECCIÓN, LIDERÁZGO Y TOMA DE DESICIONES",
                    topicId: "FP-392125",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "FINANZAS I",
                    topicId: "FP-392126",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "COMPORTAMIENTO HUMANO EN LAS ORGANIZACIONES",
                    topicId: "FP-392127",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "INVESTIGACIÓN DE OPERACIONES",
                    topicId: "FP-392128",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "FUNDAMENTOS DE LA MERCADOTECNIA ",
                    topicId: "FP-392129",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "SISTEMAS DE INFORMACIÓN PARA LAS EMPRESAS",
                    topicId: "FP-392130",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        6: {
            description: "6to cuatrimestre",
            materias: [
                {
                    name: "NEGOCIOS GLOBALES",
                    topicId: "FP-392131",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "FINANZAS II",
                    topicId: "FP-392132",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "OPERACIONES I",
                    topicId: "FP-392133",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ADMINISTRACIÓN DE PROYECTOS",
                    topicId: "FP-392134",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "MERCADOTECNIA DIGITAL",
                    topicId: "FP-392135",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        7: {
            description: "7mo cuatrimestre",
            materias: [
                {
                    name: "AUDITORÍA ADMINISTRATIVA I",
                    topicId: "FP-392136",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "FINANZAS INTERNACIONALES",
                    topicId: "FP-392137",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "OPERACIONES II",
                    topicId: "FP-392138",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ADMINISTRACIÓN DE LA MIPyME",
                    topicId: "FP-392139",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "COACHING GERENCIAL",
                    topicId: "FP-392140",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        8: {
            description: "8vo cuatrimestre",
            materias: [
                {
                    name: "PRESUPUESTOS",
                    topicId: "FE-392141",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "AUDITORÍA ADMINISTRATIVA II",
                    topicId: "FE-392142",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "RELACIONES PÚBLICAS",
                    topicId: "FE-392143",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "DESARROLLO EMPRESARIAL",
                    topicId: "FE-392144",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ADMINISTRACIÓN DE LOS COSTOS",
                    topicId: "FE-392145",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        9: {
            description: "9no cuatrimestre",
            materias: [
                {
                    name: "PLANEACIÓN ESTRATÉGICA",
                    topicId: "FE-392146",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "CALIDAD TOTAL",
                    topicId: "FE-392147",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "SEMINARIO DE TESIS",
                    topicId: "FE-392148",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "DIAGNÓSTICO ORGANIZACIONAL",
                    topicId: "FE-392149",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "DESARROLLO SUSTENTABLE CORPORATIVO",
                    topicId: "FE-392150",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        }
    },
    industrial: {
        1: {
            description: "1er cuatrimestre",
            materias: [
                {
                    name: "INTRODUCCIÓN A LA INGENIERÍA INDUSTRIAL",
                    topicId: "FB-392101",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: false,
                    objective: "Identificar el desarrollo histórico de la administración; analizar las principales escuelas " +
                        "de la teoría administrativa, sus aportaciones, técnicas, su función y relación con el contexto " +
                        "social, evaluar y enfocar la administración en nuestro país y valorar la necesidad social, perfil, " +
                        "campos de actuación y código de ética de la administración."
                },
                {
                    name: "MATEMATICAS I",
                    topicId: "FB-392102",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: false,
                    objective: "Identificar la naturaleza de la contabilidad, sus normas de actuación, el significado de la " +
                        "información financiera y los principios de contabilidad. Conocer y elaborar el estado de situación " +
                        "financiera (balance general) y el estado de resultados, explicar la partida doble y la cuenta y su " +
                        "aplicación en el registro de operaciones."
                },
                {
                    name: "HERRAMIENTAS TECNOLÓGICAS",
                    topicId: "FB-392103",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: false,
                    objective: "Identificar el uso en las empresas de las TIC´s para toma de decisiones estratégicas, a partir de la comprensión de las ventajas que otorga emplear dispositivos electrónicos, plataformas y aplicaciones de uso empresarial, considerando de igual forma las medidas de seguridad necesarias para cuidar a la organización."
                },
                {
                    name: "DERECHO LABORAL",
                    topicId: "FB-392104",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    temas: [
                        {
                            descripcion: "Funciones matemáticas y ecuaciones lineales.",
                            horasIndependientes: 15,
                            horasDocente: 10,
                            subtemas: [
                                {subtema: "1.1 Definición"},
                                {subtema: "1.2 Dominio y rango restringidos"},
                                {subtema: "1.3 Funciones multivariadas básicas"},
                                {subtema: "1.4 Representaciones gráficas de funciones matemáticas"},
                                {subtema: "1.5 Formula pendiente intersección"},
                                {subtema: "1.6 Determinación de la ecuación de una línea recta "},
                            ]
                        },
                        {
                            descripcion: "Aplicaciones de funciones lineales y sistemas de ecuaciones",
                            horasIndependientes: 15,
                            horasDocente: 10,
                            subtemas: [
                                {subtema: "2.1 Funciones lineales "},
                                {subtema: "2.2 Modelos de equilibrio "},
                                {subtema: "2.3 Sistemas de ecuaciones lineales "},
                            ]
                        },
                        {
                            descripcion: "Álgebra matricial", horasIndependientes: 20, horasDocente: 10,
                            subtemas: [
                                {subtema: "3.1 Introducción a las matrices"},
                                {subtema: "3.2 Tipos de matrices"},
                                {subtema: "3.3 Operaciones con matrices"},
                                {subtema: "3.4 Introducción a los determinantes"},
                                {subtema: "3.5 Propiedades de los determinantes"},
                                {subtema: "3.6 Solución de una matriz inversa"},
                                {subtema: "3.7 Aplicaciones"},
                            ]
                        },
                        {
                            descripcion: "Cálculo diferencial e integral", horasIndependientes: 20, horasDocente: 12,
                            subtemas: [
                                {subtema: "4.1 Límites y continuidad de una función"},
                                {subtema: "4.2 Derivadas"},
                                {subtema: "4.3 Aplicaciones de la derivada"},
                                {subtema: "4.4 Antiderivada"},
                                {subtema: "4.5 Integrales"},
                                {subtema: "4.6 Aplicación del cálculo integral"},
                            ]
                        },
                    ],
                    disabled: false,
                    objective: "Aplicar el lenguaje algebraico mediante la interpretación y operación de expresiones matemáticas, así como su representación gráfica correspondiente para formular y resolver problemas.",
                    actividadesConAcademico: [
                        {actividad: "Revisará en la plataforma institucional el avance de las participaciones, tareas, trabajos y demás aspectos  para la evaluación de los aprendizajes."},
                        {actividad: "Orientación, guía y acompañamiento al estudiante en su proceso de aprendizaje, a partir de tareas, trabajos y demás aspectos que fomenten el trabajo independiente y colaborativo a distancia."},
                        {actividad: "Asesoría a través de la plataforma educativa institucional con el apoyo de herramientas para la educación a distancia: chad, foro de diálogo, salas virtuales, carpeta de lecciones, carpeta de actividades, y correo electrónico institucional."},
                        {actividad: "Revisión con el alumno del plan de trabajo ofreciendo las instrucciones detalles sobre la preparación de las unidades, temas, trabajos a elaborar, actividades , prácticas, ejercicios, herramientas digitales, requisitos para exámenes de evaluación y otras sugeridas previamente por el docente para reforzar el proceso de enseñanza-aprendizaje a distancia."},
                        {actividad: "Implementar estrategias para que los estudiantes realicen actividades orientadas a la solución de problemas, construcción de modelos matemáticos, utilizando las herramientas disponibles en la plataforma educativa institucional y sitios de internet afines a la asignatura. "},
                        {actividad: "Aplicará acciones para su evaluación, retroalimentación y reforzamiento del aprendizaje."},
                    ],
                    actividadesIndependientes: [
                        {actividad: "Participar en las actividades establecidas en la Plataforma Educativa Institucional en donde deberá cumplir puntualmente con todas aquellas que indique el docente."},
                        {actividad: "Establecer un calendario que le permita la realización oportuna de sus actividades escolares y todas aquellas acciones que le faciliten el cumplimiento del plan de trabajo establecido de antemano por el académico."},
                        {actividad: "Seleccionar las estrategias de trabajo que le faciliten la adquisición, comprensión y utilización de información para apropiarse del conocimiento."},
                        {actividad: "Formular dudas concretas, comentarios y aportaciones profesionales, para promover el diálogo y la discusión con el académico y los compañeros, en la Plataforma Educativa Institucional, para generar información pertinente para todos los participantes. "},
                        {actividad: "Aplicar las herramientas didácticas digitales con las que reforzará el conocimiento por adquirir."},
                        {actividad: "Realizar trabajo de investigación previo a las sesiones virtuales"},
                        {actividad: "Consulta bibliográfica en la biblioteca virtual"},
                        {actividad: "Resolución de ejercicios propuestos utilizando las herramientas disponibles en la plataforma educativa institucional. "},
                        {actividad: "Representar gráficamente las funciones matemáticas propuestas con la herramienta digital disponible en la plataforma virtual o la aplicación sugerida."},
                    ],
                    evaluacion: {
                        procedimientos: [
                            {procedimiento: "Evaluaciones parciales."},
                            {procedimiento: "Evaluación final."},
                            {procedimiento: "Trabajos y tareas establecidos en la Plataforma Educativa Institucional"},
                            {procedimiento: "Participación en foros, chats y salas en la Plataforma Educativa Institucional."},
                            {procedimiento: "Proyectos y/o prácticas en colaboración."},
                        ],
                        acreditacion: "Las evaluaciones se efectuarán en la forma y condiciones que el programa académico establezca. Los resultados de las evaluaciones se efectuarán en las fechas señaladas por el departamento de control escolar, bajo la escala numérica del 5 al 10, considerando como calificación mínima aprobatoria seis.",
                        rubricas: [
                            {
                                rubrica: "Evaluaciones de conocimiento parciales.",
                                porcentaje: 15,
                                porcentajeString: "15%"
                            },
                            {
                                rubrica: "Practicar dos exámenes como mínimo durante el curso.",
                                porcentaje: 15,
                                porcentajeString: "15%"
                            },
                            {
                                rubrica: "Trabajos de investigación, tareas, participación en clase, asistencia a conferencias y demás aspectos susceptibles de ser evaluados.",
                                porcentaje: 15,
                                porcentajeString: "15%"
                            },
                            {
                                rubrica: "Participación en foros, chats y salas en la Plataforma Educativa Institucional.",
                                porcentaje: 30,
                                porcentajeString: "30%"
                            },
                            {
                                rubrica: "Proyectos y/o prácticas en colaboración.",
                                porcentaje: 25,
                                porcentajeString: "25%"
                            },
                        ]
                    },
                    recursos: [
                        {recurso: "Entorno de aprendizaje virtual: Plataforma educativa institucional"},
                        {recurso: "Chat virtual para diálogo con los estudiantes"},
                        {recurso: "Correo electrónico institucional"},
                        {recurso: "Foro de discusión virtual"},
                        {recurso: "Biblioteca Digital"},
                        {recurso: "Videoconferencias "},
                        {recurso: "Webinars de temas especializados"},
                        {recurso: "Aplicaciones para generar presentaciones digitales"},
                        {recurso: "Pizarra digital"},
                    ]
                },
                {
                    name: "METODOLOGÍA DE LA INVESTIGACIÓN",
                    topicId: "FB-392105",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Proporcionar al estudiante las herramientas y conocimientos para la realización de investigación documentada y experimental, así como las bases para la interpretación, discusión y presentación de resultados para explicar fenómenos de la sociedad y aplicarlo en su formación profesional y laboral."
                },
                {
                    name: "CONCEPTOS JURÍDICOS",
                    topicId: "FB-392106",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "El alumno comprenderá los conceptos jurídicos fundamentales, que le sirvan de fundamento en sus estudios de preparación en el área económico-administrativa a la que pertenece."
                },
            ]
        },
        2: {
            description: "2do cuatrimestre",
            materias: [
                {
                    name: "PROCESO ADMINISTRATIVO",
                    topicId: "FB-392107",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Describir, analizar y relacionar las etapas del proceso administrativo, con las áreas funcionales en las organizaciones y su relación con las áreas funcionales de la organización.",
                },
                {
                    name: "CONTABILIDAD ADMINISTRATIVA",
                    topicId: "FB-392108",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Utilizar la Contabilidad Administrativa como una herramienta útil en la toma de decisiones dentro del proceso de planeación y control de las organizaciones. Así como registrar operaciones de compra y venta de mercancías aplicando métodos de valuación de inventarios, manuales y electrónicos.",
                },
                {
                    name: "COMERCIO ELECTRÓNICO",
                    topicId: "FB-392109",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Evaluar los recursos y herramientas existentes para brindar soluciones a las empresas que buscan incursionar en el comercio en el entorno digital.",
                },
                {
                    name: "MATEMÁTICAS FINANCIERAS",
                    topicId: "FB-392110",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Evaluar los modelos financieros aplicando los principios matemáticos referentes a la variación del dinero en el tiempo.",
                },
                {
                    name: "MACROECONOMÍA",
                    topicId: "FB-392111",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Utilizar los conceptos de la teoría económica, evaluar las relaciones macroeconómicas y emplear las leyes económicas como instrumento de análisis.",
                },
                {
                    name: "DERECHO MERCANTIL",
                    topicId: "FB-392112",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Analizar la necesidad e importancia del derecho mercantil, las personas que intervienen, los actos de comercio, la empresa y sus elementos, los contratos mercantiles, títulos y operaciones de crédito determinando su aplicación.",
                },
            ]
        },
        3: {
            description: "3er cuatrimestre",
            materias: [
                {
                    name: "MARCO ORGANIZACIONAL DE LA ADMINISTRACIÓN",
                    topicId: "FB-392113",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Señalar la problemática existente en las organizaciones, analizar, diseñar o rediseñar la estructura de la organización y formular el manual de organización.",
                },
                {
                    name: "EMPRENDIMIENTO",
                    topicId: "FB-392114",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Conocer el proceso de creación de empresas, las etapas para generar el plan de negocio, el producto/servicio a ofrecer en el mercado, financiamiento y consolidación.",
                },
                {
                    name: "CAPITAL HUMANO I",
                    topicId: "FB-392115",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Comprender el papel estratégico de la administración del capital humano en las organizaciones, los sistemas de información empleados en su manejo, y la funcionalidad del análisis y diseño de puestos.",
                },
                {
                    name: "ANÁLISIS ESTADÍSTICO I",
                    topicId: "FB-392116",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "MICROECONOMÍA",
                    topicId: "FB-392117",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "DERECHO LABORAL",
                    topicId: "FB-392118",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        4: {
            description: "4to cuatrimestre",
            materias: [
                {
                    name: "SISTEMAS ADMINISTRATIVOS EN LAS ORGANIZACIONES",
                    topicId: "FP-392119",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ENTORNO ECONÓMICO DE MÉXICO",
                    topicId: "FP-392120",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "PSICOLOGÍA ORGANIZACIONAL",
                    topicId: "FP-392121",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "CAPITAL HUMANO II",
                    topicId: "FP-392122",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ANÁLISIS ESTADÍSTICO II",
                    topicId: "FP-392123",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "CIBER SEGURIDAD EN LAS EMPRESAS ",
                    topicId: "FP-392124",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        5: {
            description: "5to cuatrimestre",
            materias: [
                {
                    name: "DIRECCIÓN, LIDERÁZGO Y TOMA DE DESICIONES",
                    topicId: "FP-392125",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "FINANZAS I",
                    topicId: "FP-392126",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "COMPORTAMIENTO HUMANO EN LAS ORGANIZACIONES",
                    topicId: "FP-392127",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "INVESTIGACIÓN DE OPERACIONES",
                    topicId: "FP-392128",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "FUNDAMENTOS DE LA MERCADOTECNIA ",
                    topicId: "FP-392129",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "SISTEMAS DE INFORMACIÓN PARA LAS EMPRESAS",
                    topicId: "FP-392130",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        6: {
            description: "6to cuatrimestre",
            materias: [
                {
                    name: "NEGOCIOS GLOBALES",
                    topicId: "FP-392131",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "FINANZAS II",
                    topicId: "FP-392132",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "OPERACIONES I",
                    topicId: "FP-392133",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ADMINISTRACIÓN DE PROYECTOS",
                    topicId: "FP-392134",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "MERCADOTECNIA DIGITAL",
                    topicId: "FP-392135",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        7: {
            description: "7mo cuatrimestre",
            materias: [
                {
                    name: "AUDITORÍA ADMINISTRATIVA I",
                    topicId: "FP-392136",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "FINANZAS INTERNACIONALES",
                    topicId: "FP-392137",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "OPERACIONES II",
                    topicId: "FP-392138",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ADMINISTRACIÓN DE LA MIPyME",
                    topicId: "FP-392139",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "COACHING GERENCIAL",
                    topicId: "FP-392140",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        8: {
            description: "8vo cuatrimestre",
            materias: [
                {
                    name: "PRESUPUESTOS",
                    topicId: "FE-392141",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "AUDITORÍA ADMINISTRATIVA II",
                    topicId: "FE-392142",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "RELACIONES PÚBLICAS",
                    topicId: "FE-392143",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "DESARROLLO EMPRESARIAL",
                    topicId: "FE-392144",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ADMINISTRACIÓN DE LOS COSTOS",
                    topicId: "FE-392145",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        9: {
            description: "9no cuatrimestre",
            materias: [
                {
                    name: "PLANEACIÓN ESTRATÉGICA",
                    topicId: "FE-392146",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "CALIDAD TOTAL",
                    topicId: "FE-392147",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "SEMINARIO DE TESIS",
                    topicId: "FE-392148",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "DIAGNÓSTICO ORGANIZACIONAL",
                    topicId: "FE-392149",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "DESARROLLO SUSTENTABLE CORPORATIVO",
                    topicId: "FE-392150",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        }
    },
    petrolera: {
        1: {
            description: "1er cuatrimestre",
            materias: [
                {
                    name: "ADMINISTRACIÓN ",
                    topicId: "FB-392101",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: false,
                    objective: "Identificar el desarrollo histórico de la administración; analizar las principales escuelas " +
                        "de la teoría administrativa, sus aportaciones, técnicas, su función y relación con el contexto " +
                        "social, evaluar y enfocar la administración en nuestro país y valorar la necesidad social, perfil, " +
                        "campos de actuación y código de ética de la administración."
                },
                {
                    name: "CONTABILIDAD ",
                    topicId: "FB-392102",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: false,
                    objective: "Identificar la naturaleza de la contabilidad, sus normas de actuación, el significado de la " +
                        "información financiera y los principios de contabilidad. Conocer y elaborar el estado de situación " +
                        "financiera (balance general) y el estado de resultados, explicar la partida doble y la cuenta y su " +
                        "aplicación en el registro de operaciones."
                },
                {
                    name: "TECNOLOGÍAS DE LA INFORMACIÓN Y COMUNICACIÓN ",
                    topicId: "FB-392103",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: false,
                    objective: "Identificar el uso en las empresas de las TIC´s para toma de decisiones estratégicas, a partir de la comprensión de las ventajas que otorga emplear dispositivos electrónicos, plataformas y aplicaciones de uso empresarial, considerando de igual forma las medidas de seguridad necesarias para cuidar a la organización."
                },
                {
                    name: "MATÉMATICAS PARA ADMINISTRACIÓN",
                    topicId: "FB-392104",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    temas: [
                        {
                            descripcion: "Funciones matemáticas y ecuaciones lineales.",
                            horasIndependientes: 15,
                            horasDocente: 10,
                            subtemas: [
                                {subtema: "1.1 Definición"},
                                {subtema: "1.2 Dominio y rango restringidos"},
                                {subtema: "1.3 Funciones multivariadas básicas"},
                                {subtema: "1.4 Representaciones gráficas de funciones matemáticas"},
                                {subtema: "1.5 Formula pendiente intersección"},
                                {subtema: "1.6 Determinación de la ecuación de una línea recta "},
                            ]
                        },
                        {
                            descripcion: "Aplicaciones de funciones lineales y sistemas de ecuaciones",
                            horasIndependientes: 15,
                            horasDocente: 10,
                            subtemas: [
                                {subtema: "2.1 Funciones lineales "},
                                {subtema: "2.2 Modelos de equilibrio "},
                                {subtema: "2.3 Sistemas de ecuaciones lineales "},
                            ]
                        },
                        {
                            descripcion: "Álgebra matricial", horasIndependientes: 20, horasDocente: 10,
                            subtemas: [
                                {subtema: "3.1 Introducción a las matrices"},
                                {subtema: "3.2 Tipos de matrices"},
                                {subtema: "3.3 Operaciones con matrices"},
                                {subtema: "3.4 Introducción a los determinantes"},
                                {subtema: "3.5 Propiedades de los determinantes"},
                                {subtema: "3.6 Solución de una matriz inversa"},
                                {subtema: "3.7 Aplicaciones"},
                            ]
                        },
                        {
                            descripcion: "Cálculo diferencial e integral", horasIndependientes: 20, horasDocente: 12,
                            subtemas: [
                                {subtema: "4.1 Límites y continuidad de una función"},
                                {subtema: "4.2 Derivadas"},
                                {subtema: "4.3 Aplicaciones de la derivada"},
                                {subtema: "4.4 Antiderivada"},
                                {subtema: "4.5 Integrales"},
                                {subtema: "4.6 Aplicación del cálculo integral"},
                            ]
                        },
                    ],
                    disabled: false,
                    objective: "Aplicar el lenguaje algebraico mediante la interpretación y operación de expresiones matemáticas, así como su representación gráfica correspondiente para formular y resolver problemas.",
                    actividadesConAcademico: [
                        {actividad: "Revisará en la plataforma institucional el avance de las participaciones, tareas, trabajos y demás aspectos  para la evaluación de los aprendizajes."},
                        {actividad: "Orientación, guía y acompañamiento al estudiante en su proceso de aprendizaje, a partir de tareas, trabajos y demás aspectos que fomenten el trabajo independiente y colaborativo a distancia."},
                        {actividad: "Asesoría a través de la plataforma educativa institucional con el apoyo de herramientas para la educación a distancia: chad, foro de diálogo, salas virtuales, carpeta de lecciones, carpeta de actividades, y correo electrónico institucional."},
                        {actividad: "Revisión con el alumno del plan de trabajo ofreciendo las instrucciones detalles sobre la preparación de las unidades, temas, trabajos a elaborar, actividades , prácticas, ejercicios, herramientas digitales, requisitos para exámenes de evaluación y otras sugeridas previamente por el docente para reforzar el proceso de enseñanza-aprendizaje a distancia."},
                        {actividad: "Implementar estrategias para que los estudiantes realicen actividades orientadas a la solución de problemas, construcción de modelos matemáticos, utilizando las herramientas disponibles en la plataforma educativa institucional y sitios de internet afines a la asignatura. "},
                        {actividad: "Aplicará acciones para su evaluación, retroalimentación y reforzamiento del aprendizaje."},
                    ],
                    actividadesIndependientes: [
                        {actividad: "Participar en las actividades establecidas en la Plataforma Educativa Institucional en donde deberá cumplir puntualmente con todas aquellas que indique el docente."},
                        {actividad: "Establecer un calendario que le permita la realización oportuna de sus actividades escolares y todas aquellas acciones que le faciliten el cumplimiento del plan de trabajo establecido de antemano por el académico."},
                        {actividad: "Seleccionar las estrategias de trabajo que le faciliten la adquisición, comprensión y utilización de información para apropiarse del conocimiento."},
                        {actividad: "Formular dudas concretas, comentarios y aportaciones profesionales, para promover el diálogo y la discusión con el académico y los compañeros, en la Plataforma Educativa Institucional, para generar información pertinente para todos los participantes. "},
                        {actividad: "Aplicar las herramientas didácticas digitales con las que reforzará el conocimiento por adquirir."},
                        {actividad: "Realizar trabajo de investigación previo a las sesiones virtuales"},
                        {actividad: "Consulta bibliográfica en la biblioteca virtual"},
                        {actividad: "Resolución de ejercicios propuestos utilizando las herramientas disponibles en la plataforma educativa institucional. "},
                        {actividad: "Representar gráficamente las funciones matemáticas propuestas con la herramienta digital disponible en la plataforma virtual o la aplicación sugerida."},
                    ],
                    evaluacion: {
                        procedimientos: [
                            {procedimiento: "Evaluaciones parciales."},
                            {procedimiento: "Evaluación final."},
                            {procedimiento: "Trabajos y tareas establecidos en la Plataforma Educativa Institucional"},
                            {procedimiento: "Participación en foros, chats y salas en la Plataforma Educativa Institucional."},
                            {procedimiento: "Proyectos y/o prácticas en colaboración."},
                        ],
                        acreditacion: "Las evaluaciones se efectuarán en la forma y condiciones que el programa académico establezca. Los resultados de las evaluaciones se efectuarán en las fechas señaladas por el departamento de control escolar, bajo la escala numérica del 5 al 10, considerando como calificación mínima aprobatoria seis.",
                        rubricas: [
                            {
                                rubrica: "Evaluaciones de conocimiento parciales.",
                                porcentaje: 15,
                                porcentajeString: "15%"
                            },
                            {
                                rubrica: "Practicar dos exámenes como mínimo durante el curso.",
                                porcentaje: 15,
                                porcentajeString: "15%"
                            },
                            {
                                rubrica: "Trabajos de investigación, tareas, participación en clase, asistencia a conferencias y demás aspectos susceptibles de ser evaluados.",
                                porcentaje: 15,
                                porcentajeString: "15%"
                            },
                            {
                                rubrica: "Participación en foros, chats y salas en la Plataforma Educativa Institucional.",
                                porcentaje: 30,
                                porcentajeString: "30%"
                            },
                            {
                                rubrica: "Proyectos y/o prácticas en colaboración.",
                                porcentaje: 25,
                                porcentajeString: "25%"
                            },
                        ]
                    },
                    recursos: [
                        {recurso: "Entorno de aprendizaje virtual: Plataforma educativa institucional"},
                        {recurso: "Chat virtual para diálogo con los estudiantes"},
                        {recurso: "Correo electrónico institucional"},
                        {recurso: "Foro de discusión virtual"},
                        {recurso: "Biblioteca Digital"},
                        {recurso: "Videoconferencias "},
                        {recurso: "Webinars de temas especializados"},
                        {recurso: "Aplicaciones para generar presentaciones digitales"},
                        {recurso: "Pizarra digital"},
                    ]
                },
                {
                    name: "METODOLOGÍA DE LA INVESTIGACIÓN",
                    topicId: "FB-392105",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Proporcionar al estudiante las herramientas y conocimientos para la realización de investigación documentada y experimental, así como las bases para la interpretación, discusión y presentación de resultados para explicar fenómenos de la sociedad y aplicarlo en su formación profesional y laboral."
                },
                {
                    name: "CONCEPTOS JURÍDICOS",
                    topicId: "FB-392106",
                    cuatrimestre: "1",
                    cuatrimestreDesc: "1er Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "El alumno comprenderá los conceptos jurídicos fundamentales, que le sirvan de fundamento en sus estudios de preparación en el área económico-administrativa a la que pertenece."
                },
            ]
        },
        2: {
            description: "2do cuatrimestre",
            materias: [
                {
                    name: "PROCESO ADMINISTRATIVO",
                    topicId: "FB-392107",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Describir, analizar y relacionar las etapas del proceso administrativo, con las áreas funcionales en las organizaciones y su relación con las áreas funcionales de la organización.",
                },
                {
                    name: "CONTABILIDAD ADMINISTRATIVA",
                    topicId: "FB-392108",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Utilizar la Contabilidad Administrativa como una herramienta útil en la toma de decisiones dentro del proceso de planeación y control de las organizaciones. Así como registrar operaciones de compra y venta de mercancías aplicando métodos de valuación de inventarios, manuales y electrónicos.",
                },
                {
                    name: "COMERCIO ELECTRÓNICO",
                    topicId: "FB-392109",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Evaluar los recursos y herramientas existentes para brindar soluciones a las empresas que buscan incursionar en el comercio en el entorno digital.",
                },
                {
                    name: "MATEMÁTICAS FINANCIERAS",
                    topicId: "FB-392110",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Evaluar los modelos financieros aplicando los principios matemáticos referentes a la variación del dinero en el tiempo.",
                },
                {
                    name: "MACROECONOMÍA",
                    topicId: "FB-392111",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Utilizar los conceptos de la teoría económica, evaluar las relaciones macroeconómicas y emplear las leyes económicas como instrumento de análisis.",
                },
                {
                    name: "DERECHO MERCANTIL",
                    topicId: "FB-392112",
                    cuatrimestre: "2",
                    cuatrimestreDesc: "2do Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Analizar la necesidad e importancia del derecho mercantil, las personas que intervienen, los actos de comercio, la empresa y sus elementos, los contratos mercantiles, títulos y operaciones de crédito determinando su aplicación.",
                },
            ]
        },
        3: {
            description: "3er cuatrimestre",
            materias: [
                {
                    name: "MARCO ORGANIZACIONAL DE LA ADMINISTRACIÓN",
                    topicId: "FB-392113",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Señalar la problemática existente en las organizaciones, analizar, diseñar o rediseñar la estructura de la organización y formular el manual de organización.",
                },
                {
                    name: "EMPRENDIMIENTO",
                    topicId: "FB-392114",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Conocer el proceso de creación de empresas, las etapas para generar el plan de negocio, el producto/servicio a ofrecer en el mercado, financiamiento y consolidación.",
                },
                {
                    name: "CAPITAL HUMANO I",
                    topicId: "FB-392115",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true,
                    objective: "Comprender el papel estratégico de la administración del capital humano en las organizaciones, los sistemas de información empleados en su manejo, y la funcionalidad del análisis y diseño de puestos.",
                },
                {
                    name: "ANÁLISIS ESTADÍSTICO I",
                    topicId: "FB-392116",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "MICROECONOMÍA",
                    topicId: "FB-392117",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "DERECHO LABORAL",
                    topicId: "FB-392118",
                    cuatrimestre: "3",
                    cuatrimestreDesc: "3to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        4: {
            description: "4to cuatrimestre",
            materias: [
                {
                    name: "SISTEMAS ADMINISTRATIVOS EN LAS ORGANIZACIONES",
                    topicId: "FP-392119",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ENTORNO ECONÓMICO DE MÉXICO",
                    topicId: "FP-392120",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "PSICOLOGÍA ORGANIZACIONAL",
                    topicId: "FP-392121",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "CAPITAL HUMANO II",
                    topicId: "FP-392122",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ANÁLISIS ESTADÍSTICO II",
                    topicId: "FP-392123",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "CIBER SEGURIDAD EN LAS EMPRESAS ",
                    topicId: "FP-392124",
                    cuatrimestre: "4",
                    cuatrimestreDesc: "4to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        5: {
            description: "5to cuatrimestre",
            materias: [
                {
                    name: "DIRECCIÓN, LIDERÁZGO Y TOMA DE DESICIONES",
                    topicId: "FP-392125",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "FINANZAS I",
                    topicId: "FP-392126",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "COMPORTAMIENTO HUMANO EN LAS ORGANIZACIONES",
                    topicId: "FP-392127",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "INVESTIGACIÓN DE OPERACIONES",
                    topicId: "FP-392128",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "FUNDAMENTOS DE LA MERCADOTECNIA ",
                    topicId: "FP-392129",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "SISTEMAS DE INFORMACIÓN PARA LAS EMPRESAS",
                    topicId: "FP-392130",
                    cuatrimestre: "5",
                    cuatrimestreDesc: "5to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        6: {
            description: "6to cuatrimestre",
            materias: [
                {
                    name: "NEGOCIOS GLOBALES",
                    topicId: "FP-392131",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "FINANZAS II",
                    topicId: "FP-392132",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "OPERACIONES I",
                    topicId: "FP-392133",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ADMINISTRACIÓN DE PROYECTOS",
                    topicId: "FP-392134",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "MERCADOTECNIA DIGITAL",
                    topicId: "FP-392135",
                    cuatrimestre: "6",
                    cuatrimestreDesc: "6to Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        7: {
            description: "7mo cuatrimestre",
            materias: [
                {
                    name: "AUDITORÍA ADMINISTRATIVA I",
                    topicId: "FP-392136",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "FINANZAS INTERNACIONALES",
                    topicId: "FP-392137",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "OPERACIONES II",
                    topicId: "FP-392138",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ADMINISTRACIÓN DE LA MIPyME",
                    topicId: "FP-392139",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "COACHING GERENCIAL",
                    topicId: "FP-392140",
                    cuatrimestre: "7",
                    cuatrimestreDesc: "7mo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        8: {
            description: "8vo cuatrimestre",
            materias: [
                {
                    name: "PRESUPUESTOS",
                    topicId: "FE-392141",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "AUDITORÍA ADMINISTRATIVA II",
                    topicId: "FE-392142",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "RELACIONES PÚBLICAS",
                    topicId: "FE-392143",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "DESARROLLO EMPRESARIAL",
                    topicId: "FE-392144",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "ADMINISTRACIÓN DE LOS COSTOS",
                    topicId: "FE-392145",
                    cuatrimestre: "8",
                    cuatrimestreDesc: "8vo Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        },
        9: {
            description: "9no cuatrimestre",
            materias: [
                {
                    name: "PLANEACIÓN ESTRATÉGICA",
                    topicId: "FE-392146",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "CALIDAD TOTAL",
                    topicId: "FE-392147",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "SEMINARIO DE TESIS",
                    topicId: "FE-392148",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "DIAGNÓSTICO ORGANIZACIONAL",
                    topicId: "FE-392149",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
                {
                    name: "DESARROLLO SUSTENTABLE CORPORATIVO",
                    topicId: "FE-392150",
                    cuatrimestre: "9",
                    cuatrimestreDesc: "9no Cuatrimestre",
                    type: "materia",
                    subtemas: [],
                    disabled: true
                },
            ]
        }
    }
};

export const RESOURCES_TYPES = {
    EXTERNAL_LINK: "EXTERNAL-LINK",
    VIDEO: "VIDEO",
    APOYO: "APOYO",
    RUBRICA: "RUBRICA",
    EJERCICIOS: "EJERCICIOS",
    YOUTUBE: "YOUTUBE",
    EXAM: "EXAM"
}

export const UVT_MATERIAS_BY_TOPIC_ID = {
    "FB-392101" : {
        name: "ADMINISTRACIÓN",
        topicId: "FB-392101",
        cuatrimestre: "1",
        cuatrimestreDesc: "1er Cuatrimestre",
        type: "materia",
        videoBienvenida: {url: "https://uvt-public-assets.s3-us-west-1.amazonaws.com/VideoIntroAdmin.mp4"},
        temas: [
            {descripcion: "1. Funciones matemáticas y ecuaciones lineales.", horasIndependientes: 15, horasDocente: 10,
                objetivo: "Aplicar las funciones matemáticas en la solución de problemas y representarlas gráficamente.",
                subtemas: [
                    {
                        subtema: "1.1 Definición", recursos: [
                            {type: RESOURCES_TYPES.VIDEO, url: "/1.1-video.mp4", title: "Definición de funciones"},
                            {type: RESOURCES_TYPES.APOYO, url: "/1.1-apoyo.pdf", title: "Apoyo de la unidad"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.1-rubrica.docx", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.1-ejercicios.pdf", title: "Ejercicios", dueDate: "06/11/2021"},
                        ]
                    },
                    {
                        subtema: "1.2 Dominio y rango restringidos", recursos: [
                            {type: RESOURCES_TYPES.VIDEO, url: "/1.2-video.mp4", title: "Dominio y rangos"},
                            {type: RESOURCES_TYPES.APOYO, url: "/1.2-presentacion-dominio-y-rango-restringuido.pptx", title: "Presentación Dominio y Rango Restringido"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/CHZ4M-7hRMo"},
                        ]
                    },
                    {
                        subtema: "1.3 Funciones multivariadas básicas", recursos: [
                            {type: RESOURCES_TYPES.APOYO, url: "/1.3-presentacion-funciones-multivariadas.pptx", title: "Presentación de funciones multivariadas"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.3-ejercicios.pdf", title: "Ejercicios", dueDate: "06/18/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.3-rubrica.pdf", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/-mI5EfGY4mo"},

                        ]
                    },
                    {
                        subtema: "1.4 Representaciones gráficas de funciones matemáticas", recursos: [
                            {type: RESOURCES_TYPES.APOYO, url: "/1.4-apoyo-representacion-de-funciones.pptx"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.4-ejercicios.docx", title: "Ejercicios", dueDate: "06/25/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.4-rubrica.pdf"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/9f7E2p9jiT4"},
                        ]
                    },
                    {
                        subtema: "1.5 Formula pendiente intersección", recursos: [
                            {type: RESOURCES_TYPES.APOYO, url: "/1.5-presentacion-formula-pendiente-interseccion.pptx"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.5-ejercicios.pdf", title: "Ejercicios", dueDate: "07/02/2021"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/ZW1NiNpGNnY"},
                        ]
                    },
                    {
                        subtema: "1.6 Determinación de la ecuación de una línea recta", recursos: [
                            {type: RESOURCES_TYPES.APOYO, url: "/1.6-presentacion-ecuacion-de-la-linea-recta.pptx"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/X6ze-8FjrtY"},
                            {type: RESOURCES_TYPES.EXAM, url: "https://youtu.be/X6ze-8FjrtY", dueDate: "07/09/2021"},
                        ]
                    },
                ]
            },
            {descripcion: "2. Aplicaciones de funciones lineales y sistemas de ecuaciones", horasIndependientes: 15, horasDocente: 10,
                objetivo: "Solucionar y aplicar los diferentes métodos de solución de sistemas de ecuaciones en problemas de punto de equilibrio y equilibrio en el mercado.",
                subtemas: [
                    {
                        subtema: "2.1 Funciones lineales", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/PnATAsxu_oo"},
                        ]
                    },
                    {
                        subtema: "2.2 Modelos de equilibrio", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/zWr64MoJri0"},
                        ]
                    },
                    {
                        subtema: "2.3 Sistemas de ecuaciones lineales", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/E_-dm2CF3wM "},
                        ]
                    },
                ]
            },
            {descripcion: "3. Álgebra matricial", horasIndependientes: 20, horasDocente: 10,
                objetivo: "Aplicar la notación de una matriz para la representación matricial de datos, sus operaciones matemáticas y solucionar problemas de sistemas de ecuaciones aplicando para resolver casos del área económica administrativa ",
                subtemas: [
                    {
                        subtema: "3.1 Introducción a las matrices", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/wM9gO8_RrDY"},
                        ]
                    },
                    {
                        subtema: "3.2 Tipos de matrices", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/xnV6rJcDcrs"},
                        ]
                    },
                    {
                        subtema: "3.3 Operaciones con matrices", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/enuxmn-A6E8"},
                        ]
                    },
                    {
                        subtema: "3.4 Introducción a los determinantes", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/ckeT2SIszgo"},
                        ]
                    },
                    {
                        subtema: "3.5 Propiedades de los determinantes", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/NBuwTaZjD5M"},
                        ]
                    },
                    {
                        subtema: "3.6 Solución de una matriz inversa", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/NBuwTaZjD5M"},
                        ]
                    },
                    {
                        subtema: "3.7 Aplicaciones", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/W-ckSat-wj8"},
                        ]
                    },
                ]
            },
            {descripcion: "4. Cálculo diferencial e integral", horasIndependientes: 20, horasDocente: 12,
                objetivo: "Comprender los conceptos de límite y continuidad para la solución de problemas relativos a tasa promedio de cambio e incrementos y aplicar las reglas de diferenciación a problemas  de máximos y mínimos como la metodología en la aplicación a ingresos, costos y utilidad. Resolver problemas de integrales definidas en la aplicación de problemas relativos a área económico y administrativo. ",
                subtemas: [
                    {
                        subtema: "4.1 Límites y continuidad de una función", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/o2UTk8bsLS0"},
                        ]
                    },
                    {
                        subtema: "4.2 Derivadas", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/uK4-s0ojHFg"},
                        ]
                    },
                    {
                        subtema: "4.3 Aplicaciones de la derivada", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/U7ZUAyVFbxM"},
                        ]
                    },
                    {
                        subtema: "4.4 Antiderivada", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/f7q0BU50JDc"},
                        ]
                    },
                    {
                        subtema: "4.5 Integrales", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/d7Y9Om4KCUM"},
                        ]
                    },
                    {
                        subtema: "4.6 Aplicación del cálculo integral", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/WMxFmNZhZNU"},
                        ]
                    },
                ]
            },
        ],
        disabled: false,
        objective: "Aplicar el lenguaje algebraico mediante la interpretación y operación de expresiones matemáticas, así como su representación gráfica correspondiente para formular y resolver problemas.",
        actividadesConAcademico: [
            {actividad: "Revisará en la plataforma institucional el avance de las participaciones, tareas, trabajos y demás aspectos  para la evaluación de los aprendizajes."},
            {actividad: "Orientación, guía y acompañamiento al estudiante en su proceso de aprendizaje, a partir de tareas, trabajos y demás aspectos que fomenten el trabajo independiente y colaborativo a distancia."},
            {actividad: "Asesoría a través de la plataforma educativa institucional con el apoyo de herramientas para la educación a distancia: chad, foro de diálogo, salas virtuales, carpeta de lecciones, carpeta de actividades, y correo electrónico institucional."},
            {actividad: "Revisión con el alumno del plan de trabajo ofreciendo las instrucciones detalles sobre la preparación de las unidades, temas, trabajos a elaborar, actividades , prácticas, ejercicios, herramientas digitales, requisitos para exámenes de evaluación y otras sugeridas previamente por el docente para reforzar el proceso de enseñanza-aprendizaje a distancia."},
            {actividad: "Implementar estrategias para que los estudiantes realicen actividades orientadas a la solución de problemas, construcción de modelos matemáticos, utilizando las herramientas disponibles en la plataforma educativa institucional y sitios de internet afines a la asignatura. "},
            {actividad: "Aplicará acciones para su evaluación, retroalimentación y reforzamiento del aprendizaje."},
        ],
        actividadesIndependientes: [
            {actividad: "Participar en las actividades establecidas en la Plataforma Educativa Institucional en donde deberá cumplir puntualmente con todas aquellas que indique el docente."},
            {actividad: "Establecer un calendario que le permita la realización oportuna de sus actividades escolares y todas aquellas acciones que le faciliten el cumplimiento del plan de trabajo establecido de antemano por el académico."},
            {actividad: "Seleccionar las estrategias de trabajo que le faciliten la adquisición, comprensión y utilización de información para apropiarse del conocimiento."},
            {actividad: "Formular dudas concretas, comentarios y aportaciones profesionales, para promover el diálogo y la discusión con el académico y los compañeros, en la Plataforma Educativa Institucional, para generar información pertinente para todos los participantes. "},
            {actividad: "Aplicar las herramientas didácticas digitales con las que reforzará el conocimiento por adquirir."},
            {actividad: "Realizar trabajo de investigación previo a las sesiones virtuales"},
            {actividad: "Consulta bibliográfica en la biblioteca virtual"},
            {actividad: "Resolución de ejercicios propuestos utilizando las herramientas disponibles en la plataforma educativa institucional. "},
            {actividad: "Representar gráficamente las funciones matemáticas propuestas con la herramienta digital disponible en la plataforma virtual o la aplicación sugerida."},
        ],
        evaluacion: {
            procedimientos: [
                {procedimiento: "Evaluaciones parciales."},
                {procedimiento: "Evaluación final."},
                {procedimiento: "Trabajos y tareas establecidos en la Plataforma Educativa Institucional"},
                {procedimiento: "Participación en foros, chats y salas en la Plataforma Educativa Institucional."},
                {procedimiento: "Proyectos y/o prácticas en colaboración."},
            ],
            acreditacion: "Las evaluaciones se efectuarán en la forma y condiciones que el programa académico establezca. Los resultados de las evaluaciones se efectuarán en las fechas señaladas por el departamento de control escolar, bajo la escala numérica del 5 al 10, considerando como calificación mínima aprobatoria seis.",
            rubricas: [
                {rubrica: "Evaluaciones de conocimiento parciales.", porcentaje: 15, porcentajeString: "15%"},
                {rubrica: "Practicar dos exámenes como mínimo durante el curso.", porcentaje: 15, porcentajeString: "15%"},
                {rubrica: "Trabajos de investigación, tareas, participación en clase, asistencia a conferencias y demás aspectos susceptibles de ser evaluados.", porcentaje: 15, porcentajeString: "15%"},
                {rubrica: "Participación en foros, chats y salas en la Plataforma Educativa Institucional.", porcentaje: 30, porcentajeString: "30%"},
                {rubrica: "Proyectos y/o prácticas en colaboración.", porcentaje: 25, porcentajeString: "25%"},
            ]
        },
        recursos: [
            {recurso: "Entorno de aprendizaje virtual: Plataforma educativa institucional"},
            {recurso: "Chat virtual para diálogo con los estudiantes"},
            {recurso: "Correo electrónico institucional"},
            {recurso: "Foro de discusión virtual"},
            {recurso: "Biblioteca Digital"},
            {recurso: "Videoconferencias "},
            {recurso: "Webinars de temas especializados"},
            {recurso: "Aplicaciones para generar presentaciones digitales"},
            {recurso: "Pizarra digital"},
        ]
    },
    "FB-392102" : {
        name: "CONTABILIDAD",
        topicId: "FB-392102",
        cuatrimestre: "1",
        cuatrimestreDesc: "1er Cuatrimestre",
        type: "materia",
        videoBienvenida: {url: "https://uvt-public-assets.s3-us-west-1.amazonaws.com/VideoIntroAdmin.mp4"},
        temas: [
            {descripcion: "1. Funciones matemáticas y ecuaciones lineales.", horasIndependientes: 15, horasDocente: 10,
                objetivo: "Aplicar las funciones matemáticas en la solución de problemas y representarlas gráficamente.",
                subtemas: [
                    {
                        subtema: "1.1 Definición", recursos: [
                            {type: RESOURCES_TYPES.VIDEO, url: "/1.1-video.mp4", title: "Definición de funciones"},
                            {type: RESOURCES_TYPES.APOYO, url: "/1.1-apoyo.pdf", title: "Apoyo de la unidad"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.1-rubrica.docx", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.1-ejercicios.pdf", title: "Ejercicios", dueDate: "06/11/2021"},
                        ]
                    },
                    {
                        subtema: "1.2 Dominio y rango restringidos", recursos: [
                            {type: RESOURCES_TYPES.VIDEO, url: "/1.2-video.mp4", title: "Dominio y rangos"},
                            {type: RESOURCES_TYPES.APOYO, url: "/1.2-presentacion-dominio-y-rango-restringuido.pptx", title: "Presentación Dominio y Rango Restringido"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/CHZ4M-7hRMo"},
                        ]
                    },
                    {
                        subtema: "1.3 Funciones multivariadas básicas", recursos: [
                            {type: RESOURCES_TYPES.APOYO, url: "/1.3-presentacion-funciones-multivariadas.pptx", title: "Presentación de funciones multivariadas"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.3-ejercicios.pdf", title: "Ejercicios", dueDate: "06/18/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.3-rubrica.pdf", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/-mI5EfGY4mo"},

                        ]
                    },
                    {
                        subtema: "1.4 Representaciones gráficas de funciones matemáticas", recursos: [
                            {type: RESOURCES_TYPES.APOYO, url: "/1.4-apoyo-representacion-de-funciones.pptx"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.4-ejercicios.docx", title: "Ejercicios", dueDate: "06/25/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.4-rubrica.pdf"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/9f7E2p9jiT4"},
                        ]
                    },
                    {
                        subtema: "1.5 Formula pendiente intersección", recursos: [
                            {type: RESOURCES_TYPES.APOYO, url: "/1.5-presentacion-formula-pendiente-interseccion.pptx"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.5-ejercicios.pdf", title: "Ejercicios", dueDate: "07/02/2021"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/ZW1NiNpGNnY"},
                        ]
                    },
                    {
                        subtema: "1.6 Determinación de la ecuación de una línea recta", recursos: [
                            {type: RESOURCES_TYPES.APOYO, url: "/1.6-presentacion-ecuacion-de-la-linea-recta.pptx"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/X6ze-8FjrtY"},
                            {type: RESOURCES_TYPES.EXAM, url: "https://youtu.be/X6ze-8FjrtY", dueDate: "07/09/2021"},
                        ]
                    },
                ]
            },
            {descripcion: "2. Aplicaciones de funciones lineales y sistemas de ecuaciones", horasIndependientes: 15, horasDocente: 10,
                objetivo: "Solucionar y aplicar los diferentes métodos de solución de sistemas de ecuaciones en problemas de punto de equilibrio y equilibrio en el mercado.",
                subtemas: [
                    {
                        subtema: "2.1 Funciones lineales", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/PnATAsxu_oo"},
                        ]
                    },
                    {
                        subtema: "2.2 Modelos de equilibrio", recursos: [
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.1-ejercicios.pdf", title: "Ejercicios", dueDate: "06/11/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.1-rubrica.docx", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/zWr64MoJri0"},
                        ]
                    },
                    {
                        subtema: "2.3 Sistemas de ecuaciones lineales", recursos: [
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.1-ejercicios.pdf", title: "Ejercicios", dueDate: "06/11/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.1-rubrica.docx", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/E_-dm2CF3wM "},
                        ]
                    },
                ]
            },
            {descripcion: "3. Álgebra matricial", horasIndependientes: 20, horasDocente: 10,
                objetivo: "Aplicar la notación de una matriz para la representación matricial de datos, sus operaciones matemáticas y solucionar problemas de sistemas de ecuaciones aplicando para resolver casos del área económica administrativa ",
                subtemas: [
                    {
                        subtema: "3.1 Introducción a las matrices", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/wM9gO8_RrDY"},
                        ]
                    },
                    {
                        subtema: "3.2 Tipos de matrices", recursos: [
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.1-ejercicios.pdf", title: "Ejercicios", dueDate: "06/11/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.1-rubrica.docx", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/xnV6rJcDcrs"},
                        ]
                    },
                    {
                        subtema: "3.3 Operaciones con matrices", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/enuxmn-A6E8"},
                        ]
                    },
                    {
                        subtema: "3.4 Introducción a los determinantes", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/ckeT2SIszgo"},
                        ]
                    },
                    {
                        subtema: "3.5 Propiedades de los determinantes", recursos: [
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.1-ejercicios.pdf", title: "Ejercicios", dueDate: "06/11/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.1-rubrica.docx", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/NBuwTaZjD5M"},
                        ]
                    },
                    {
                        subtema: "3.6 Solución de una matriz inversa", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/NBuwTaZjD5M"},
                        ]
                    },
                    {
                        subtema: "3.7 Aplicaciones", recursos: [
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.1-ejercicios.pdf", title: "Ejercicios", dueDate: "06/11/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.1-rubrica.docx", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/W-ckSat-wj8"},
                        ]
                    },
                ]
            },
            {descripcion: "4. Cálculo diferencial e integral", horasIndependientes: 20, horasDocente: 12,
                objetivo: "Comprender los conceptos de límite y continuidad para la solución de problemas relativos a tasa promedio de cambio e incrementos y aplicar las reglas de diferenciación a problemas  de máximos y mínimos como la metodología en la aplicación a ingresos, costos y utilidad. Resolver problemas de integrales definidas en la aplicación de problemas relativos a área económico y administrativo. ",
                subtemas: [
                    {
                        subtema: "4.1 Límites y continuidad de una función", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/o2UTk8bsLS0"},
                        ]
                    },
                    {
                        subtema: "4.2 Derivadas", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/uK4-s0ojHFg"},
                        ]
                    },
                    {
                        subtema: "4.3 Aplicaciones de la derivada", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/U7ZUAyVFbxM"},
                        ]
                    },
                    {
                        subtema: "4.4 Antiderivada", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/f7q0BU50JDc"},
                        ]
                    },
                    {
                        subtema: "4.5 Integrales", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/d7Y9Om4KCUM"},
                        ]
                    },
                    {
                        subtema: "4.6 Aplicación del cálculo integral", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/WMxFmNZhZNU"},
                        ]
                    },
                ]
            },
        ],
        disabled: false,
        objective: "Aplicar el lenguaje algebraico mediante la interpretación y operación de expresiones matemáticas, así como su representación gráfica correspondiente para formular y resolver problemas.",
        actividadesConAcademico: [
            {actividad: "Revisará en la plataforma institucional el avance de las participaciones, tareas, trabajos y demás aspectos  para la evaluación de los aprendizajes."},
            {actividad: "Orientación, guía y acompañamiento al estudiante en su proceso de aprendizaje, a partir de tareas, trabajos y demás aspectos que fomenten el trabajo independiente y colaborativo a distancia."},
            {actividad: "Asesoría a través de la plataforma educativa institucional con el apoyo de herramientas para la educación a distancia: chad, foro de diálogo, salas virtuales, carpeta de lecciones, carpeta de actividades, y correo electrónico institucional."},
            {actividad: "Revisión con el alumno del plan de trabajo ofreciendo las instrucciones detalles sobre la preparación de las unidades, temas, trabajos a elaborar, actividades , prácticas, ejercicios, herramientas digitales, requisitos para exámenes de evaluación y otras sugeridas previamente por el docente para reforzar el proceso de enseñanza-aprendizaje a distancia."},
            {actividad: "Implementar estrategias para que los estudiantes realicen actividades orientadas a la solución de problemas, construcción de modelos matemáticos, utilizando las herramientas disponibles en la plataforma educativa institucional y sitios de internet afines a la asignatura. "},
            {actividad: "Aplicará acciones para su evaluación, retroalimentación y reforzamiento del aprendizaje."},
        ],
        actividadesIndependientes: [
            {actividad: "Participar en las actividades establecidas en la Plataforma Educativa Institucional en donde deberá cumplir puntualmente con todas aquellas que indique el docente."},
            {actividad: "Establecer un calendario que le permita la realización oportuna de sus actividades escolares y todas aquellas acciones que le faciliten el cumplimiento del plan de trabajo establecido de antemano por el académico."},
            {actividad: "Seleccionar las estrategias de trabajo que le faciliten la adquisición, comprensión y utilización de información para apropiarse del conocimiento."},
            {actividad: "Formular dudas concretas, comentarios y aportaciones profesionales, para promover el diálogo y la discusión con el académico y los compañeros, en la Plataforma Educativa Institucional, para generar información pertinente para todos los participantes. "},
            {actividad: "Aplicar las herramientas didácticas digitales con las que reforzará el conocimiento por adquirir."},
            {actividad: "Realizar trabajo de investigación previo a las sesiones virtuales"},
            {actividad: "Consulta bibliográfica en la biblioteca virtual"},
            {actividad: "Resolución de ejercicios propuestos utilizando las herramientas disponibles en la plataforma educativa institucional. "},
            {actividad: "Representar gráficamente las funciones matemáticas propuestas con la herramienta digital disponible en la plataforma virtual o la aplicación sugerida."},
        ],
        evaluacion: {
            procedimientos: [
                {procedimiento: "Evaluaciones parciales."},
                {procedimiento: "Evaluación final."},
                {procedimiento: "Trabajos y tareas establecidos en la Plataforma Educativa Institucional"},
                {procedimiento: "Participación en foros, chats y salas en la Plataforma Educativa Institucional."},
                {procedimiento: "Proyectos y/o prácticas en colaboración."},
            ],
            acreditacion: "Las evaluaciones se efectuarán en la forma y condiciones que el programa académico establezca. Los resultados de las evaluaciones se efectuarán en las fechas señaladas por el departamento de control escolar, bajo la escala numérica del 5 al 10, considerando como calificación mínima aprobatoria seis.",
            rubricas: [
                {rubrica: "Evaluaciones de conocimiento parciales.", porcentaje: 15, porcentajeString: "15%"},
                {rubrica: "Practicar dos exámenes como mínimo durante el curso.", porcentaje: 15, porcentajeString: "15%"},
                {rubrica: "Trabajos de investigación, tareas, participación en clase, asistencia a conferencias y demás aspectos susceptibles de ser evaluados.", porcentaje: 15, porcentajeString: "15%"},
                {rubrica: "Participación en foros, chats y salas en la Plataforma Educativa Institucional.", porcentaje: 30, porcentajeString: "30%"},
                {rubrica: "Proyectos y/o prácticas en colaboración.", porcentaje: 25, porcentajeString: "25%"},
            ]
        },
        recursos: [
            {recurso: "Entorno de aprendizaje virtual: Plataforma educativa institucional"},
            {recurso: "Chat virtual para diálogo con los estudiantes"},
            {recurso: "Correo electrónico institucional"},
            {recurso: "Foro de discusión virtual"},
            {recurso: "Biblioteca Digital"},
            {recurso: "Videoconferencias "},
            {recurso: "Webinars de temas especializados"},
            {recurso: "Aplicaciones para generar presentaciones digitales"},
            {recurso: "Pizarra digital"},
        ]
    },
    "FB-392103" : {
        name: "Tecnologías de la Información y Comunicación",
        topicId: "FB-392103",
        cuatrimestre: "1",
        cuatrimestreDesc: "1er Cuatrimestre",
        type: "materia",
        videoBienvenida: {url: "https://uvt-public-assets.s3-us-west-1.amazonaws.com/VideoIntroAdmin.mp4"},
        temas: [
            {descripcion: "1. Funciones matemáticas y ecuaciones lineales.", horasIndependientes: 15, horasDocente: 10,
                objetivo: "Aplicar las funciones matemáticas en la solución de problemas y representarlas gráficamente.",
                subtemas: [
                    {
                        subtema: "1.1 Definición", recursos: [
                            {type: RESOURCES_TYPES.VIDEO, url: "/1.1-video.mp4", title: "Definición de funciones"},
                            {type: RESOURCES_TYPES.APOYO, url: "/1.1-apoyo.pdf", title: "Apoyo de la unidad"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.1-ejercicios.pdf", title: "Ejercicios", dueDate: "06/11/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.1-rubrica.docx", title: "Rúbrica"},
                        ]
                    },
                    {
                        subtema: "1.2 Dominio y rango restringidos", recursos: [
                            {type: RESOURCES_TYPES.VIDEO, url: "/1.2-video.mp4", title: "Dominio y rangos"},
                            {type: RESOURCES_TYPES.APOYO, url: "/1.2-presentacion-dominio-y-rango-restringuido.pptx", title: "Presentación Dominio y Rango Restringido"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/CHZ4M-7hRMo"},
                        ]
                    },
                    {
                        subtema: "1.3 Funciones multivariadas básicas", recursos: [
                            {type: RESOURCES_TYPES.APOYO, url: "/1.3-presentacion-funciones-multivariadas.pptx", title: "Presentación de funciones multivariadas"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.3-ejercicios.pdf", title: "Ejercicios", dueDate: "06/18/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.3-rubrica.pdf", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/-mI5EfGY4mo"},

                        ]
                    },
                    {
                        subtema: "1.4 Representaciones gráficas de funciones matemáticas", recursos: [
                            {type: RESOURCES_TYPES.APOYO, url: "/1.4-apoyo-representacion-de-funciones.pptx"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.4-ejercicios.docx", title: "Ejercicios", dueDate: "06/25/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.4-rubrica.pdf"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/9f7E2p9jiT4"},
                        ]
                    },
                    {
                        subtema: "1.5 Formula pendiente intersección", recursos: [
                            {type: RESOURCES_TYPES.APOYO, url: "/1.5-presentacion-formula-pendiente-interseccion.pptx"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.5-ejercicios.pdf", title: "Ejercicios", dueDate: "07/02/2021"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/ZW1NiNpGNnY"},
                        ]
                    },
                    {
                        subtema: "1.6 Determinación de la ecuación de una línea recta", recursos: [
                            {type: RESOURCES_TYPES.APOYO, url: "/1.6-presentacion-ecuacion-de-la-linea-recta.pptx"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/X6ze-8FjrtY"},
                            {type: RESOURCES_TYPES.EXAM, url: "https://youtu.be/X6ze-8FjrtY", dueDate: "07/09/2021"},
                        ]
                    },
                ]
            },
            {descripcion: "2. Aplicaciones de funciones lineales y sistemas de ecuaciones", horasIndependientes: 15, horasDocente: 10,
                objetivo: "Solucionar y aplicar los diferentes métodos de solución de sistemas de ecuaciones en problemas de punto de equilibrio y equilibrio en el mercado.",
                subtemas: [
                    {
                        subtema: "2.1 Funciones lineales", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/PnATAsxu_oo"},
                        ]
                    },
                    {
                        subtema: "2.2 Modelos de equilibrio", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/zWr64MoJri0"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.1-ejercicios.pdf", title: "Ejercicios", dueDate: "06/11/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.1-rubrica.docx", title: "Rúbrica"},
                        ]
                    },
                    {
                        subtema: "2.3 Sistemas de ecuaciones lineales", recursos: [
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.3-ejercicios.pdf", title: "Ejercicios", dueDate: "06/18/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.3-rubrica.pdf", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/E_-dm2CF3wM "},
                        ]
                    },
                ]
            },
            {descripcion: "3. Álgebra matricial", horasIndependientes: 20, horasDocente: 10,
                objetivo: "Aplicar la notación de una matriz para la representación matricial de datos, sus operaciones matemáticas y solucionar problemas de sistemas de ecuaciones aplicando para resolver casos del área económica administrativa ",
                subtemas: [
                    {
                        subtema: "3.1 Introducción a las matrices", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/wM9gO8_RrDY"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.1-ejercicios.pdf", title: "Ejercicios", dueDate: "06/11/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.1-rubrica.docx", title: "Rúbrica"},
                        ]
                    },
                    {
                        subtema: "3.2 Tipos de matrices", recursos: [
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.3-ejercicios.pdf", title: "Ejercicios", dueDate: "06/18/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.3-rubrica.pdf", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/xnV6rJcDcrs"},
                        ]
                    },
                    {
                        subtema: "3.3 Operaciones con matrices", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/enuxmn-A6E8"},
                        ]
                    },
                    {
                        subtema: "3.4 Introducción a los determinantes", recursos: [
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.3-ejercicios.pdf", title: "Ejercicios", dueDate: "06/18/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.3-rubrica.pdf", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/ckeT2SIszgo"},
                        ]
                    },
                    {
                        subtema: "3.5 Propiedades de los determinantes", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/NBuwTaZjD5M"},
                        ]
                    },
                    {
                        subtema: "3.6 Solución de una matriz inversa", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/NBuwTaZjD5M"},
                        ]
                    },
                    {
                        subtema: "3.7 Aplicaciones", recursos: [
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.3-ejercicios.pdf", title: "Ejercicios", dueDate: "06/18/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.3-rubrica.pdf", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/W-ckSat-wj8"},
                        ]
                    },
                ]
            },
            {descripcion: "4. Cálculo diferencial e integral", horasIndependientes: 20, horasDocente: 12,
                objetivo: "Comprender los conceptos de límite y continuidad para la solución de problemas relativos a tasa promedio de cambio e incrementos y aplicar las reglas de diferenciación a problemas  de máximos y mínimos como la metodología en la aplicación a ingresos, costos y utilidad. Resolver problemas de integrales definidas en la aplicación de problemas relativos a área económico y administrativo. ",
                subtemas: [
                    {
                        subtema: "4.1 Límites y continuidad de una función", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/o2UTk8bsLS0"},
                        ]
                    },
                    {
                        subtema: "4.2 Derivadas", recursos: [
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.3-ejercicios.pdf", title: "Ejercicios", dueDate: "06/18/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.3-rubrica.pdf", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/uK4-s0ojHFg"},
                        ]
                    },
                    {
                        subtema: "4.3 Aplicaciones de la derivada", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/U7ZUAyVFbxM"},
                        ]
                    },
                    {
                        subtema: "4.4 Antiderivada", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/f7q0BU50JDc"},
                        ]
                    },
                    {
                        subtema: "4.5 Integrales", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/d7Y9Om4KCUM"},
                        ]
                    },
                    {
                        subtema: "4.6 Aplicación del cálculo integral", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/WMxFmNZhZNU"},
                        ]
                    },
                ]
            },
        ],
        disabled: false,
        objective: "Aplicar el lenguaje algebraico mediante la interpretación y operación de expresiones matemáticas, así como su representación gráfica correspondiente para formular y resolver problemas.",
        actividadesConAcademico: [
            {actividad: "Revisará en la plataforma institucional el avance de las participaciones, tareas, trabajos y demás aspectos  para la evaluación de los aprendizajes."},
            {actividad: "Orientación, guía y acompañamiento al estudiante en su proceso de aprendizaje, a partir de tareas, trabajos y demás aspectos que fomenten el trabajo independiente y colaborativo a distancia."},
            {actividad: "Asesoría a través de la plataforma educativa institucional con el apoyo de herramientas para la educación a distancia: chad, foro de diálogo, salas virtuales, carpeta de lecciones, carpeta de actividades, y correo electrónico institucional."},
            {actividad: "Revisión con el alumno del plan de trabajo ofreciendo las instrucciones detalles sobre la preparación de las unidades, temas, trabajos a elaborar, actividades , prácticas, ejercicios, herramientas digitales, requisitos para exámenes de evaluación y otras sugeridas previamente por el docente para reforzar el proceso de enseñanza-aprendizaje a distancia."},
            {actividad: "Implementar estrategias para que los estudiantes realicen actividades orientadas a la solución de problemas, construcción de modelos matemáticos, utilizando las herramientas disponibles en la plataforma educativa institucional y sitios de internet afines a la asignatura. "},
            {actividad: "Aplicará acciones para su evaluación, retroalimentación y reforzamiento del aprendizaje."},
        ],
        actividadesIndependientes: [
            {actividad: "Participar en las actividades establecidas en la Plataforma Educativa Institucional en donde deberá cumplir puntualmente con todas aquellas que indique el docente."},
            {actividad: "Establecer un calendario que le permita la realización oportuna de sus actividades escolares y todas aquellas acciones que le faciliten el cumplimiento del plan de trabajo establecido de antemano por el académico."},
            {actividad: "Seleccionar las estrategias de trabajo que le faciliten la adquisición, comprensión y utilización de información para apropiarse del conocimiento."},
            {actividad: "Formular dudas concretas, comentarios y aportaciones profesionales, para promover el diálogo y la discusión con el académico y los compañeros, en la Plataforma Educativa Institucional, para generar información pertinente para todos los participantes. "},
            {actividad: "Aplicar las herramientas didácticas digitales con las que reforzará el conocimiento por adquirir."},
            {actividad: "Realizar trabajo de investigación previo a las sesiones virtuales"},
            {actividad: "Consulta bibliográfica en la biblioteca virtual"},
            {actividad: "Resolución de ejercicios propuestos utilizando las herramientas disponibles en la plataforma educativa institucional. "},
            {actividad: "Representar gráficamente las funciones matemáticas propuestas con la herramienta digital disponible en la plataforma virtual o la aplicación sugerida."},
        ],
        evaluacion: {
            procedimientos: [
                {procedimiento: "Evaluaciones parciales."},
                {procedimiento: "Evaluación final."},
                {procedimiento: "Trabajos y tareas establecidos en la Plataforma Educativa Institucional"},
                {procedimiento: "Participación en foros, chats y salas en la Plataforma Educativa Institucional."},
                {procedimiento: "Proyectos y/o prácticas en colaboración."},
            ],
            acreditacion: "Las evaluaciones se efectuarán en la forma y condiciones que el programa académico establezca. Los resultados de las evaluaciones se efectuarán en las fechas señaladas por el departamento de control escolar, bajo la escala numérica del 5 al 10, considerando como calificación mínima aprobatoria seis.",
            rubricas: [
                {rubrica: "Evaluaciones de conocimiento parciales.", porcentaje: 15, porcentajeString: "15%"},
                {rubrica: "Practicar dos exámenes como mínimo durante el curso.", porcentaje: 15, porcentajeString: "15%"},
                {rubrica: "Trabajos de investigación, tareas, participación en clase, asistencia a conferencias y demás aspectos susceptibles de ser evaluados.", porcentaje: 15, porcentajeString: "15%"},
                {rubrica: "Participación en foros, chats y salas en la Plataforma Educativa Institucional.", porcentaje: 30, porcentajeString: "30%"},
                {rubrica: "Proyectos y/o prácticas en colaboración.", porcentaje: 25, porcentajeString: "25%"},
            ]
        },
        recursos: [
            {recurso: "Entorno de aprendizaje virtual: Plataforma educativa institucional"},
            {recurso: "Chat virtual para diálogo con los estudiantes"},
            {recurso: "Correo electrónico institucional"},
            {recurso: "Foro de discusión virtual"},
            {recurso: "Biblioteca Digital"},
            {recurso: "Videoconferencias "},
            {recurso: "Webinars de temas especializados"},
            {recurso: "Aplicaciones para generar presentaciones digitales"},
            {recurso: "Pizarra digital"},
        ]
    },
    "FB-392104" : {
        name: "MATÉMATICAS PARA ADMINISTRACIÓN",
        topicId: "FB-392104",
        cuatrimestre: "1",
        cuatrimestreDesc: "1er Cuatrimestre",
        type: "materia",
        videoBienvenida: {url: "https://uvt-public-assets.s3-us-west-1.amazonaws.com/VideoIntroAdmin.mp4"},
        temas: [
            {descripcion: "1. Funciones matemáticas y ecuaciones lineales.", horasIndependientes: 15, horasDocente: 10,
                objetivo: "Aplicar las funciones matemáticas en la solución de problemas y representarlas gráficamente.",
                subtemas: [
                    {
                        subtema: "1.1 Definición", recursos: [
                            {type: RESOURCES_TYPES.VIDEO, url: "/1.1-video.mp4", title: "Definición de funciones"},
                            {type: RESOURCES_TYPES.APOYO, url: "/1.1-apoyo.pdf", title: "Apoyo de la unidad"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.1-rubrica.docx", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.1-ejercicios.pdf", title: "Ejercicios", dueDate: "06/11/2021"},
                        ]
                    },
                    {
                        subtema: "1.2 Dominio y rango restringidos", recursos: [
                            {type: RESOURCES_TYPES.VIDEO, url: "/1.2-video.mp4", title: "Dominio y rangos"},
                            {type: RESOURCES_TYPES.APOYO, url: "/1.2-presentacion-dominio-y-rango-restringuido.pptx", title: "Presentación Dominio y Rango Restringido"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/CHZ4M-7hRMo"},
                        ]
                    },
                    {
                        subtema: "1.3 Funciones multivariadas básicas", recursos: [
                            {type: RESOURCES_TYPES.APOYO, url: "/1.3-presentacion-funciones-multivariadas.pptx", title: "Presentación de funciones multivariadas"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.3-ejercicios.pdf", title: "Ejercicios", dueDate: "06/18/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.3-rubrica.pdf", title: "Rúbrica"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/-mI5EfGY4mo"},

                        ]
                    },
                    {
                        subtema: "1.4 Representaciones gráficas de funciones matemáticas", recursos: [
                            {type: RESOURCES_TYPES.APOYO, url: "/1.4-apoyo-representacion-de-funciones.pptx"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.4-ejercicios.docx", title: "Ejercicios", dueDate: "06/25/2021"},
                            {type: RESOURCES_TYPES.RUBRICA, url: "/1.4-rubrica.pdf"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/9f7E2p9jiT4"},
                        ]
                    },
                    {
                        subtema: "1.5 Formula pendiente intersección", recursos: [
                            {type: RESOURCES_TYPES.APOYO, url: "/1.5-presentacion-formula-pendiente-interseccion.pptx"},
                            {type: RESOURCES_TYPES.EJERCICIOS, url: "/1.5-ejercicios.pdf", title: "Ejercicios", dueDate: "07/02/2021"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/ZW1NiNpGNnY"},
                        ]
                    },
                    {
                        subtema: "1.6 Determinación de la ecuación de una línea recta", recursos: [
                            {type: RESOURCES_TYPES.APOYO, url: "/1.6-presentacion-ecuacion-de-la-linea-recta.pptx"},
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/X6ze-8FjrtY"},
                            {type: RESOURCES_TYPES.EXAM, url: "https://youtu.be/X6ze-8FjrtY", dueDate: "07/09/2021"},
                        ]
                    },
                ]
            },
            {descripcion: "2. Aplicaciones de funciones lineales y sistemas de ecuaciones", horasIndependientes: 15, horasDocente: 10,
                objetivo: "Solucionar y aplicar los diferentes métodos de solución de sistemas de ecuaciones en problemas de punto de equilibrio y equilibrio en el mercado.",
                subtemas: [
                    {
                        subtema: "2.1 Funciones lineales", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/PnATAsxu_oo"},
                        ]
                    },
                    {
                        subtema: "2.2 Modelos de equilibrio", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/zWr64MoJri0"},
                        ]
                    },
                    {
                        subtema: "2.3 Sistemas de ecuaciones lineales", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/E_-dm2CF3wM "},
                        ]
                    },
                ]
            },
            {descripcion: "3. Álgebra matricial", horasIndependientes: 20, horasDocente: 10,
                objetivo: "Aplicar la notación de una matriz para la representación matricial de datos, sus operaciones matemáticas y solucionar problemas de sistemas de ecuaciones aplicando para resolver casos del área económica administrativa ",
                subtemas: [
                    {
                        subtema: "3.1 Introducción a las matrices", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/wM9gO8_RrDY"},
                        ]
                    },
                    {
                        subtema: "3.2 Tipos de matrices", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/xnV6rJcDcrs"},
                        ]
                    },
                    {
                        subtema: "3.3 Operaciones con matrices", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/enuxmn-A6E8"},
                        ]
                    },
                    {
                        subtema: "3.4 Introducción a los determinantes", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/ckeT2SIszgo"},
                        ]
                    },
                    {
                        subtema: "3.5 Propiedades de los determinantes", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/NBuwTaZjD5M"},
                        ]
                    },
                    {
                        subtema: "3.6 Solución de una matriz inversa", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/NBuwTaZjD5M"},
                        ]
                    },
                    {
                        subtema: "3.7 Aplicaciones", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/W-ckSat-wj8"},
                        ]
                    },
                ]
            },
            {descripcion: "4. Cálculo diferencial e integral", horasIndependientes: 20, horasDocente: 12,
                objetivo: "Comprender los conceptos de límite y continuidad para la solución de problemas relativos a tasa promedio de cambio e incrementos y aplicar las reglas de diferenciación a problemas  de máximos y mínimos como la metodología en la aplicación a ingresos, costos y utilidad. Resolver problemas de integrales definidas en la aplicación de problemas relativos a área económico y administrativo. ",
                subtemas: [
                    {
                        subtema: "4.1 Límites y continuidad de una función", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/o2UTk8bsLS0"},
                        ]
                    },
                    {
                        subtema: "4.2 Derivadas", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/uK4-s0ojHFg"},
                        ]
                    },
                    {
                        subtema: "4.3 Aplicaciones de la derivada", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/U7ZUAyVFbxM"},
                        ]
                    },
                    {
                        subtema: "4.4 Antiderivada", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/f7q0BU50JDc"},
                        ]
                    },
                    {
                        subtema: "4.5 Integrales", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/d7Y9Om4KCUM"},
                        ]
                    },
                    {
                        subtema: "4.6 Aplicación del cálculo integral", recursos: [
                            {type: RESOURCES_TYPES.YOUTUBE, url: "https://youtu.be/WMxFmNZhZNU"},
                        ]
                    },
                ]
            },
        ],
        disabled: false,
        objective: "Aplicar el lenguaje algebraico mediante la interpretación y operación de expresiones matemáticas, así como su representación gráfica correspondiente para formular y resolver problemas.",
        actividadesConAcademico: [
            {actividad: "Revisará en la plataforma institucional el avance de las participaciones, tareas, trabajos y demás aspectos  para la evaluación de los aprendizajes."},
            {actividad: "Orientación, guía y acompañamiento al estudiante en su proceso de aprendizaje, a partir de tareas, trabajos y demás aspectos que fomenten el trabajo independiente y colaborativo a distancia."},
            {actividad: "Asesoría a través de la plataforma educativa institucional con el apoyo de herramientas para la educación a distancia: chad, foro de diálogo, salas virtuales, carpeta de lecciones, carpeta de actividades, y correo electrónico institucional."},
            {actividad: "Revisión con el alumno del plan de trabajo ofreciendo las instrucciones detalles sobre la preparación de las unidades, temas, trabajos a elaborar, actividades , prácticas, ejercicios, herramientas digitales, requisitos para exámenes de evaluación y otras sugeridas previamente por el docente para reforzar el proceso de enseñanza-aprendizaje a distancia."},
            {actividad: "Implementar estrategias para que los estudiantes realicen actividades orientadas a la solución de problemas, construcción de modelos matemáticos, utilizando las herramientas disponibles en la plataforma educativa institucional y sitios de internet afines a la asignatura. "},
            {actividad: "Aplicará acciones para su evaluación, retroalimentación y reforzamiento del aprendizaje."},
        ],
        actividadesIndependientes: [
            {actividad: "Participar en las actividades establecidas en la Plataforma Educativa Institucional en donde deberá cumplir puntualmente con todas aquellas que indique el docente."},
            {actividad: "Establecer un calendario que le permita la realización oportuna de sus actividades escolares y todas aquellas acciones que le faciliten el cumplimiento del plan de trabajo establecido de antemano por el académico."},
            {actividad: "Seleccionar las estrategias de trabajo que le faciliten la adquisición, comprensión y utilización de información para apropiarse del conocimiento."},
            {actividad: "Formular dudas concretas, comentarios y aportaciones profesionales, para promover el diálogo y la discusión con el académico y los compañeros, en la Plataforma Educativa Institucional, para generar información pertinente para todos los participantes. "},
            {actividad: "Aplicar las herramientas didácticas digitales con las que reforzará el conocimiento por adquirir."},
            {actividad: "Realizar trabajo de investigación previo a las sesiones virtuales"},
            {actividad: "Consulta bibliográfica en la biblioteca virtual"},
            {actividad: "Resolución de ejercicios propuestos utilizando las herramientas disponibles en la plataforma educativa institucional. "},
            {actividad: "Representar gráficamente las funciones matemáticas propuestas con la herramienta digital disponible en la plataforma virtual o la aplicación sugerida."},
        ],
        evaluacion: {
            procedimientos: [
                {procedimiento: "Evaluaciones parciales."},
                {procedimiento: "Evaluación final."},
                {procedimiento: "Trabajos y tareas establecidos en la Plataforma Educativa Institucional"},
                {procedimiento: "Participación en foros, chats y salas en la Plataforma Educativa Institucional."},
                {procedimiento: "Proyectos y/o prácticas en colaboración."},
            ],
            acreditacion: "Las evaluaciones se efectuarán en la forma y condiciones que el programa académico establezca. Los resultados de las evaluaciones se efectuarán en las fechas señaladas por el departamento de control escolar, bajo la escala numérica del 5 al 10, considerando como calificación mínima aprobatoria seis.",
            rubricas: [
                {rubrica: "Evaluaciones de conocimiento parciales.", porcentaje: 15, porcentajeString: "15%"},
                {rubrica: "Practicar dos exámenes como mínimo durante el curso.", porcentaje: 15, porcentajeString: "15%"},
                {rubrica: "Trabajos de investigación, tareas, participación en clase, asistencia a conferencias y demás aspectos susceptibles de ser evaluados.", porcentaje: 15, porcentajeString: "15%"},
                {rubrica: "Participación en foros, chats y salas en la Plataforma Educativa Institucional.", porcentaje: 30, porcentajeString: "30%"},
                {rubrica: "Proyectos y/o prácticas en colaboración.", porcentaje: 25, porcentajeString: "25%"},
            ]
        },
        recursos: [
            {recurso: "Entorno de aprendizaje virtual: Plataforma educativa institucional"},
            {recurso: "Chat virtual para diálogo con los estudiantes"},
            {recurso: "Correo electrónico institucional"},
            {recurso: "Foro de discusión virtual"},
            {recurso: "Biblioteca Digital"},
            {recurso: "Videoconferencias "},
            {recurso: "Webinars de temas especializados"},
            {recurso: "Aplicaciones para generar presentaciones digitales"},
            {recurso: "Pizarra digital"},
        ]
    }
}
